import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, vShow as _vShow, vModelText as _vModelText, TransitionGroup as _TransitionGroup, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Transition as _Transition } from "vue"
import _imports_0 from './assets/img/foil.svg'
import _imports_1 from './assets/img/bot-score.svg'
import _imports_2 from './assets/img/cards.svg'
import _imports_3 from './assets/img/Creature.svg'
import _imports_4 from './assets/img/Land_symbol_white.svg'
import _imports_5 from './assets/img/vault.png'
import _imports_6 from './assets/img/draft_queue_banner_tmt.webp'
import _imports_7 from './assets/img/cube.png'
import _imports_8 from './assets/img/cubecobra-small-logo.png'


const _hoisted_1 = {
  id: "view-controls",
  class: "main-controls"
}
const _hoisted_2 = { class: "inline" }
const _hoisted_3 = ["value", "selected"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { style: {"display":"inline-flex","gap":"0.75em","align-items":"center","margin-right":"0.25em","vertical-align":"middle"} }
const _hoisted_6 = { class: "inline" }
const _hoisted_7 = { class: "personal-settings" }
const _hoisted_8 = {
  key: 0,
  class: "generic-container"
}
const _hoisted_9 = { id: "session-controls" }
const _hoisted_10 = {
  class: "inline",
  style: {"margin-right":"0.25em"}
}
const _hoisted_11 = { style: {"display":"inline-flex","gap":"0.3em","align-items":"center","margin-left":"0.25em","vertical-align":"middle"} }
const _hoisted_12 = { class: "generic-container card-pool-controls" }
const _hoisted_13 = {
  class: "inline-cube-name",
  style: {"vertical-align":"text-top"}
}
const _hoisted_14 = { style: {"display":"inline-flex","gap":"0.25em","align-items":"center","vertical-align":"middle"} }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  class: "clickable",
  onclick: "document.querySelector('#card-list-input-main').click()"
}
const _hoisted_18 = { class: "inline" }
const _hoisted_19 = { for: "bots" }
const _hoisted_20 = ["max"]
const _hoisted_21 = { for: "timer" }
const _hoisted_22 = { class: "game-modes-cat" }
const _hoisted_23 = { class: "game-modes-cat" }
const _hoisted_24 = {
  key: 0,
  class: "controls-drafting-mask"
}
const _hoisted_25 = { id: "draft-in-progress" }
const _hoisted_26 = {
  key: 0,
  class: "inline-cube-name remove-below-1200",
  style: {"vertical-align":"bottom","max-width":"22em"}
}
const _hoisted_27 = { id: "draft-controls" }
const _hoisted_28 = {
  key: 1,
  class: "main-controls session-players"
}
const _hoisted_29 = { class: "session-players-header" }
const _hoisted_30 = {
  key: 0,
  class: "generic-container",
  style: {"flex":"0 3 auto","text-align":"center"}
}
const _hoisted_31 = { class: "non-playing-session-owner-name" }
const _hoisted_32 = ["id"]
const _hoisted_33 = { style: {"flex":"0 3 auto","text-align":"center","font-size":"0.8em","margin-right":"0.5em"} }
const _hoisted_34 = { class: "player-list-container" }
const _hoisted_35 = {
  key: 1,
  class: "player-list"
}
const _hoisted_36 = { class: "chat" }
const _hoisted_37 = { class: "main-content" }
const _hoisted_38 = { class: "generic-container" }
const _hoisted_39 = {
  key: "draft-watching",
  class: "draft-watching"
}
const _hoisted_40 = { class: "draft-watching-state" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { key: 3 }
const _hoisted_45 = { key: 4 }
const _hoisted_46 = {
  key: 0,
  class: "draft-watching-live-log"
}
const _hoisted_47 = {
  id: "booster-controls",
  class: "section-title"
}
const _hoisted_48 = {
  class: "controls",
  style: {"flex-grow":"2"}
}
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 2 }
const _hoisted_53 = { key: 3 }
const _hoisted_54 = { key: 2 }
const _hoisted_55 = ["value"]
const _hoisted_56 = { key: 3 }
const _hoisted_57 = ["value"]
const _hoisted_58 = {
  class: "wait",
  key: "wait"
}
const _hoisted_59 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_60 = { class: "chrono" }
const _hoisted_61 = { class: "section-title" }
const _hoisted_62 = { class: "controls" }
const _hoisted_63 = { style: {"flex-grow":"1"} }
const _hoisted_64 = { class: "section-title controls" }
const _hoisted_65 = {
  class: "controls",
  style: {"flex-grow":"2"}
}
const _hoisted_66 = { key: 1 }
const _hoisted_67 = {
  key: 0,
  class: "disconnected-user-popup-container"
}
const _hoisted_68 = { class: "disconnected-user-popup" }
const _hoisted_69 = {
  key: 0,
  style: {"margin-top":"1em"}
}
const _hoisted_70 = {
  key: 0,
  class: "disconnected-user-popup-container"
}
const _hoisted_71 = { class: "disconnected-user-popup" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { style: {"margin-top":"1em"} }
const _hoisted_75 = {
  key: 0,
  style: {"padding":"0.5em 1em 0 1em"}
}
const _hoisted_76 = {
  key: 0,
  href: "/draftqueue"
}
const _hoisted_77 = { class: "deck-and-sideboard" }
const _hoisted_78 = { class: "container deck-container" }
const _hoisted_79 = { class: "deck" }
const _hoisted_80 = { class: "deck-stat" }
const _hoisted_81 = { class: "deck-stat" }
const _hoisted_82 = { style: {"display":"flex","justify-content":"space-around"} }
const _hoisted_83 = { style: {"margin":"auto"} }
const _hoisted_84 = ["src"]
const _hoisted_85 = { style: {"font-size":"0.75em","color":"#bbb"} }
const _hoisted_86 = {
  key: 0,
  style: {"display":"flex","align-items":"center","justify-content":"space-evenly","margin":"0.25em 0 0 0"}
}
const _hoisted_87 = { style: {"font-size":"0.8em"} }
const _hoisted_88 = { class: "deck-search input-delete-icon remove-below-1000" }
const _hoisted_89 = { class: "swap-controls" }
const _hoisted_90 = {
  key: 0,
  class: "collapsed-sideboard"
}
const _hoisted_91 = { class: "section-title" }
const _hoisted_92 = { style: {"font-size":"0.8em"} }
const _hoisted_93 = {
  class: "controls",
  style: {"margin-left":"auto"}
}
const _hoisted_94 = { class: "container sideboard" }
const _hoisted_95 = {
  key: 1,
  class: "welcome"
}
const _hoisted_96 = { class: "welcome-top" }
const _hoisted_97 = { class: "welcome-sections" }
const _hoisted_98 = {
  class: "container",
  style: {"grid-area":"News"}
}
const _hoisted_99 = {
  class: "container",
  style: {"grid-area":"Help"}
}
const _hoisted_100 = { class: "welcome-section welcome-alt" }
const _hoisted_101 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_102 = { href: "https://discord.gg/XscXXNw" }
const _hoisted_103 = {
  class: "container",
  style: {"grid-area":"Support"}
}
const _hoisted_104 = { class: "section-title" }
const _hoisted_105 = { class: "welcome-section welcome-alt" }
const _hoisted_106 = { style: {"display":"flex","gap":"1em","justify-content":"center","align-items":"center","text-align":"center","margin":"0.25em","margin-bottom":"0.8em"} }
const _hoisted_107 = { style: {"position":"relative"} }
const _hoisted_108 = {
  href: "https://github.com/sponsors/Senryoku",
  target: "_blank"
}
const _hoisted_109 = {
  href: "https://www.paypal.com/donate/?hosted_button_id=6L2CUS6DH82DL",
  target: "_blank"
}
const _hoisted_110 = {
  class: "container",
  style: {"grid-area":"Tools"}
}
const _hoisted_111 = { class: "welcome-section welcome-alt" }
const _hoisted_112 = { style: {"display":"flex","flex-wrap":"wrap","justify-content":"space-between"} }
const _hoisted_113 = { key: 0 }
const _hoisted_114 = ["href"]
const _hoisted_115 = {
  class: "container",
  style: {"grid-area":"PublicSessions"}
}
const _hoisted_116 = { class: "welcome-section" }
const _hoisted_117 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_118 = {
  key: 1,
  style: {"text-align":"center"}
}
const _hoisted_119 = {
  key: 2,
  class: "public-sessions"
}
const _hoisted_120 = ["title"]
const _hoisted_121 = {
  key: 0,
  src: _imports_7,
  class: "set-icon"
}
const _hoisted_122 = ["src"]
const _hoisted_123 = { class: "desc" }
const _hoisted_124 = ["onClick"]
const _hoisted_125 = { class: "option-column option-column-left" }
const _hoisted_126 = { class: "line" }
const _hoisted_127 = { class: "right" }
const _hoisted_128 = { class: "line" }
const _hoisted_129 = { class: "right" }
const _hoisted_130 = { class: "line" }
const _hoisted_131 = { class: "right" }
const _hoisted_132 = { class: "line" }
const _hoisted_133 = { class: "right" }
const _hoisted_134 = { class: "right" }
const _hoisted_135 = { class: "right" }
const _hoisted_136 = { class: "right" }
const _hoisted_137 = { class: "right" }
const _hoisted_138 = ["checked"]
const _hoisted_139 = { class: "option-column-title" }
const _hoisted_140 = ["for"]
const _hoisted_141 = { class: "right" }
const _hoisted_142 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_143 = { class: "option-column-title" }
const _hoisted_144 = ["checked"]
const _hoisted_145 = ["for"]
const _hoisted_146 = { class: "right" }
const _hoisted_147 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_148 = { class: "line" }
const _hoisted_149 = { class: "right" }
const _hoisted_150 = { class: "line" }
const _hoisted_151 = { class: "right" }
const _hoisted_152 = { class: "line" }
const _hoisted_153 = { class: "right" }
const _hoisted_154 = { class: "right" }
const _hoisted_155 = { class: "option-column option-column-right" }
const _hoisted_156 = { class: "line" }
const _hoisted_157 = { class: "right" }
const _hoisted_158 = { class: "line" }
const _hoisted_159 = { class: "right" }
const _hoisted_160 = { class: "line" }
const _hoisted_161 = { style: {"max-height":"10em","overflow-y":"auto","margin":"0.2em","padding-bottom":"0.4em"} }
const _hoisted_162 = { for: "customized-booster" }
const _hoisted_163 = ["onUpdate:modelValue"]
const _hoisted_164 = ["value"]
const _hoisted_165 = ["value"]
const _hoisted_166 = { class: "line" }
const _hoisted_167 = { class: "right" }
const _hoisted_168 = { class: "line" }
const _hoisted_169 = { class: "right" }
const _hoisted_170 = { class: "line" }
const _hoisted_171 = { class: "right" }
const _hoisted_172 = ["max"]
const _hoisted_173 = { class: "line" }
const _hoisted_174 = { class: "right" }
const _hoisted_175 = { class: "line" }
const _hoisted_176 = { class: "right" }
const _hoisted_177 = { class: "line" }
const _hoisted_178 = { class: "right" }
const _hoisted_179 = { class: "line" }
const _hoisted_180 = { class: "right" }
const _hoisted_181 = { class: "line" }
const _hoisted_182 = { class: "right" }
const _hoisted_183 = { class: "option-column-title" }
const _hoisted_184 = { class: "option-cube-settings" }
const _hoisted_185 = ["checked"]
const _hoisted_186 = {
  key: 0,
  class: "option-cube-settings-2"
}
const _hoisted_187 = { key: 2 }
const _hoisted_188 = {
  class: "inline-cube-name",
  style: {"vertical-align":"bottom"}
}
const _hoisted_189 = { key: 3 }
const _hoisted_190 = { key: 1 }
const _hoisted_191 = { class: "option-cube-import" }
const _hoisted_192 = { style: {"display":"flex","align-items":"center","justify-content":"space-around","flex-direction":"column","min-width":"17em"} }
const _hoisted_193 = { class: "option-cube-select" }
const _hoisted_194 = ["value"]
const _hoisted_195 = {
  key: 0,
  style: {"font-size":"0.75em"}
}
const _hoisted_196 = {
  key: 0,
  class: "set-icon",
  src: _imports_8
}
const _hoisted_197 = {
  key: 0,
  class: "option-cube-infos"
}
const _hoisted_198 = { key: 0 }
const _hoisted_199 = ["href"]
const _hoisted_200 = ["innerHTML"]
const _hoisted_201 = { class: "option-info" }
const _hoisted_202 = {
  href: "https://cubecobra.com/",
  target: "_blank",
  rel: "noopener nofollow"
}
const _hoisted_203 = {
  href: "cubeformat.html",
  target: "_blank",
  rel: "noopener nofollow"
}
const _hoisted_204 = {
  href: "mailto:dev@draftmancer.com",
  title: "Email"
}
const _hoisted_205 = {
  href: "https://discord.gg/XscXXNw",
  title: "Discord",
  target: "_blank",
  rel: "noopener nofollow"
}
const _hoisted_206 = {
  href: "https://github.com/Senryoku/Draftmancer",
  title: "GitHub",
  target: "_blank",
  rel: "noopener nofollow"
}
const _hoisted_207 = {
  key: 2,
  class: "disconnected-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_delayed_input = _resolveComponent("delayed-input")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_font_awesome_layers = _resolveComponent("font-awesome-layers")!
  const _component_set_select = _resolveComponent("set-select")!
  const _component_dropdown = _resolveComponent("dropdown")!
  const _component_SessionUser = _resolveComponent("SessionUser")!
  const _component_Sortable = _resolveComponent("Sortable")!
  const _component_Player = _resolveComponent("Player")!
  const _component_ChatHistory = _resolveComponent("ChatHistory")!
  const _component_DraftLogLiveComponent = _resolveComponent("DraftLogLiveComponent")!
  const _component_scale_slider = _resolveComponent("scale-slider")!
  const _component_booster_card = _resolveComponent("booster-card")!
  const _component_winston_draft = _resolveComponent("winston-draft")!
  const _component_winchester_draft = _resolveComponent("winchester-draft")!
  const _component_housman_draft = _resolveComponent("housman-draft")!
  const _component_solomon_draft = _resolveComponent("solomon-draft")!
  const _component_silent_auction_draft = _resolveComponent("silent-auction-draft")!
  const _component_grid_draft = _resolveComponent("grid-draft")!
  const _component_pick_summary = _resolveComponent("pick-summary")!
  const _component_minesweeper_draft = _resolveComponent("minesweeper-draft")!
  const _component_team_sealed = _resolveComponent("team-sealed")!
  const _component_rotisserie_draft = _resolveComponent("rotisserie-draft")!
  const _component_ExportDropdown = _resolveComponent("ExportDropdown")!
  const _component_land_control = _resolveComponent("land-control")!
  const _component_card_pool = _resolveComponent("card-pool")!
  const _component_card = _resolveComponent("card")!
  const _component_DraftQueue = _resolveComponent("DraftQueue")!
  const _component_Communities = _resolveComponent("Communities")!
  const _component_news = _resolveComponent("news")!
  const _component_help_modal = _resolveComponent("help-modal")!
  const _component_modal = _resolveComponent("modal")!
  const _component_getting_started = _resolveComponent("getting-started")!
  const _component_CollectionImportHelp = _resolveComponent("CollectionImportHelp")!
  const _component_set_restriction_component = _resolveComponent("set-restriction-component")!
  const _component_draft_log_history = _resolveComponent("draft-log-history")!
  const _component_collection_component = _resolveComponent("collection-component")!
  const _component_bracket_component = _resolveComponent("bracket-component")!
  const _component_sample_hand_generator = _resolveComponent("sample-hand-generator")!
  const _component_card_stats = _resolveComponent("card-stats")!
  const _component_card_list = _resolveComponent("card-list")!
  const _component_About = _resolveComponent("About")!
  const _component_sponsor_modal = _resolveComponent("sponsor-modal")!
  const _component_CardPopup = _resolveComponent("CardPopup")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    id: "main-container",
    style: _normalizeStyle(`
			height: ${_ctx.displayFixedDeck ? _ctx.fixedDeckState.mainHeight : '100vh'};
			--card-back-image: url(${_ctx.cardBackImage});
			--card-title-height-factor: ${_ctx.cardTitleHeightFactor};
		`),
    class: _normalizeClass({ 'using-fixed-deck': _ctx.displayFixedDeck, 'no-foil-effect': !_ctx.foilEffect })
  }, [
    _createCommentVNode(" Personal Options "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, [
        _cache[162] || (_cache[162] = _createElementVNode("label", { for: "user-name" }, "User Name", -1 /* CACHED */)),
        _createVNode(_component_delayed_input, {
          id: "user-name",
          modelValue: _ctx.userName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userName) = $event)),
          type: "text",
          maxlength: 50,
          delay: 2,
          style: {"margin-right":"0.25em"}
        }, null, 8 /* PROPS */, ["modelValue"])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[163] || (_cache[163] = _createElementVNode("label", {
          for: "select-language",
          id: "select-language-label"
        }, "Card Language", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.language) = $event)),
          id: "select-language"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang) => {
            return (_openBlock(), _createElementBlock("option", {
              value: lang.code,
              selected: lang.code === _ctx.language,
              key: lang.code
            }, _toDisplayString(lang.name), 9 /* TEXT, PROPS */, _hoisted_3))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */), [
          [_vModelSelect, _ctx.language]
        ])
      ])), [
        [_directive_tooltip, 'Controls the display language of cards.']
      ]),
      (_ctx.sessionID && !_ctx.managed)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _createElementVNode("label", {
              class: "clickable",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayedModal = _ctx.hasCollection ? 'collection' : 'collectionHelp'))
            }, [
              _withDirectives((_openBlock(), _createBlock(_component_font_awesome_layers, null, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-book",
                    class: _normalizeClass({
								faded: !_ctx.hasCollection,
								green: _ctx.hasCollection && _ctx.useCollection,
								yellow: _ctx.hasCollection && !_ctx.useCollection,
							})
                  }, null, 8 /* PROPS */, ["class"])
                ]),
                _: 1 /* STABLE */
              })), [
                [_directive_tooltip, 
							_ctx.hasCollection
								? _ctx.useCollection
									? 'Collection uploaded.'
									: 'Collection uploaded, but not used.'
								: 'No collection uploaded.'
						]
              ]),
              _cache[164] || (_cache[164] = _createTextVNode(" MTGA Collection ", -1 /* CACHED */))
            ]),
            _createElementVNode("span", _hoisted_5, [
              _withDirectives(_createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-question-circle",
                class: "clickable",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.displayedModal = 'collectionHelp'))
              }, null, 512 /* NEED_PATCH */), [
                [_directive_tooltip, 'Collection Import Help']
              ]),
              _createElementVNode("input", {
                type: "file",
                id: "collection-file-input",
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.uploadCardListAsCollection && _ctx.uploadCardListAsCollection(...args))),
                style: {"display":"none"},
                accept: ".txt,.csv,.log"
              }, null, 32 /* NEED_HYDRATION */),
              _withDirectives((_openBlock(), _createElementBlock("span", null, [
                _createVNode(_component_font_awesome_icon, {
                  onClick: _ctx.uploadMTGALogs,
                  icon: "fa-solid fa-file-upload",
                  class: "clickable"
                }, null, 8 /* PROPS */, ["onClick"])
              ])), [
                [_directive_tooltip, 'Import your collection by uploading your Player.log file.']
              ]),
              (_ctx.hasCollection)
                ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "fa-solid fa-chart-bar",
                    class: "clickable",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.displayedModal = 'collection'))
                  }, null, 512 /* NEED_PATCH */)), [
                    [_directive_tooltip, 'Collection Statistics']
                  ])
                : _createCommentVNode("v-if", true),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.useCollection) = $event)),
                  id: "useCollection"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.useCollection]
                ]),
                _cache[165] || (_cache[165] = _createElementVNode("label", { for: "useCollection" }, "Restrict to Collection", -1 /* CACHED */))
              ])), [
                [_vShow, _ctx.hasCollection],
                [_directive_tooltip, {
							html: true,
							content: `Restrict to Collection: <strong>${
								_ctx.useCollection ? 'Enabled' : 'Disabled'
							}</strong><br />
							If enabled, your collection will be used to restrict the card pool, making sure you'll only draft with cards you already own. (Ignored when using a Custom Card List)${
								_ctx.ignoreCollections
									? '<p><strong>Warning:</strong> The session setting \'Restrict card pool to Player Collections\' is disabled, your collection is currently ignored.</p>'
									: ''
							}`,
						}]
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", null, [
        _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.displayedModal = 'draftLogs')),
          class: "flat"
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-list" }),
          _cache[166] || (_cache[166] = _createTextVNode(" Game Logs ", -1 /* CACHED */))
        ])), [
          [_directive_tooltip, 'Displays logs of your previous drafts and sealed']
        ])
      ]),
      _createElementVNode("span", _hoisted_7, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["clickable personal-settings-icon", { faded: !_ctx.foilEffect, crossed: !_ctx.foilEffect }]),
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.foilEffect = !_ctx.foilEffect)),
          tabindex: "0"
        }, [...(_cache[167] || (_cache[167] = [
          _createElementVNode("div", {
            style: {"margin-top":"1px"},
            alt: "Foil Effect Toggle"
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              width: "auto",
              height: "18px",
              alt: "Foil Effect Toggle"
            })
          ], -1 /* CACHED */)
        ]))], 2 /* CLASS */)), [
          [_directive_tooltip, {
						content: `Foil effect: <strong>${_ctx.foilEffect ? 'Enabled' : 'Disabled'}</strong>`,
						html: true,
					}]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["clickable personal-settings-icon", { faded: !_ctx.fixedDeck, crossed: !_ctx.fixedDeck }]),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.fixedDeck = !_ctx.fixedDeck)),
          tabindex: "0"
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-thumbtack",
            style: {"font-size":"1.2em","vertical-align":"-20%"}
          })
        ], 2 /* CLASS */)), [
          [_directive_tooltip, {
						content: `Deck always visible: <strong>${_ctx.fixedDeck ? 'Enabled' : 'Disabled'}</strong>`,
						html: true,
					}]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["clickable personal-settings-icon", { faded: !_ctx.pickOnDblclick, crossed: !_ctx.pickOnDblclick }]),
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.pickOnDblclick = !_ctx.pickOnDblclick)),
          tabindex: "0"
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-mouse-pointer",
            style: {"font-size":"1.2em","vertical-align":"-20%"}
          })
        ], 2 /* CLASS */)), [
          [_directive_tooltip, {
						content: `Pick cards by double clicking: <strong>${
							_ctx.pickOnDblclick ? 'Enabled' : 'Disabled'
						}</strong>`,
						html: true,
					}]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["clickable personal-settings-icon", { faded: !_ctx.displayBotScores, crossed: !_ctx.displayBotScores }]),
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.displayBotScores = !_ctx.displayBotScores)),
          tabindex: "0"
        }, [...(_cache[168] || (_cache[168] = [
          _createElementVNode("div", {
            style: {"width":"20px","margin-top":"5px"},
            alt: "Bot Recommendations Button"
          }, [
            _createElementVNode("img", {
              src: _imports_1,
              width: "20",
              height: "20",
              alt: "Bot Recommendations Button"
            })
          ], -1 /* CACHED */)
        ]))], 2 /* CLASS */)), [
          [_directive_tooltip, {
						content: `Display Bot Recommendations: <strong>${
							_ctx.displayBotScores ? 'Enabled' : 'Disabled'
						}</strong><br /><small>Note: Bot recommendations can be disabled by the session owner.</small>`,
						html: true,
					}]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["clickable personal-settings-icon", { faded: !_ctx.enableSound }]),
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.enableSound = !_ctx.enableSound)),
          tabindex: "0"
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: `fa-solid ${_ctx.enableSound ? 'fa-volume-up' : 'fa-volume-mute'}`
          }, null, 8 /* PROPS */, ["icon"])
        ], 2 /* CLASS */)), [
          [_directive_tooltip, {
						content: `Sound: <strong>${_ctx.enableSound ? 'Enabled' : 'Disabled'}</strong>`,
						html: true,
					}]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["clickable personal-settings-icon", {
						faded: !_ctx.enableNotifications,
						'greyed-out': _ctx.notificationPermission === 'denied',
					}]),
          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.toggleNotifications && _ctx.toggleNotifications(...args))),
          tabindex: "0"
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: `fa-solid ${_ctx.enableNotifications ? 'fa-bell' : 'fa-bell-slash'}`
          }, null, 8 /* PROPS */, ["icon"])
        ], 2 /* CLASS */)), [
          [_directive_tooltip, {
						content:
							_ctx.notificationPermission === 'denied'
								? 'Notifications for this domain are blocked in your browser'
								: `Desktop Notifications: <strong>${
										_ctx.enableNotifications ? 'Enabled' : 'Disabled'
									}</strong>`,
						html: true,
					}]
        ])
      ])
    ]),
    _createCommentVNode(" Session Options "),
    (_ctx.sessionID !== undefined && !_ctx.managed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", {
            id: "limited-controls",
            class: _normalizeClass(["main-controls", { disabled: _ctx.drafting }])
          }, [
            _createElementVNode("span", _hoisted_9, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[169] || (_cache[169] = _createElementVNode("label", { for: "session-id" }, "Session", -1 /* CACHED */)),
                _createVNode(_component_delayed_input, {
                  modelValue: _ctx.sessionID,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.sessionID) = $event)),
                  autocomplete: "off",
                  id: "session-id",
                  type: _ctx.hideSessionID ? 'password' : 'text',
                  maxlength: 50,
                  delay: 2
                }, null, 8 /* PROPS */, ["modelValue", "type"])
              ])), [
                [_directive_tooltip, 
							'Unique ID of your game session. Create a new session by entering a name of your choice.'
						]
              ]),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createVNode(_component_font_awesome_icon, {
                  class: "fa-regular clickable",
                  icon: 'fa-regular ' + (_ctx.hideSessionID ? 'fa-eye' : 'fa-eye-slash'),
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.hideSessionID = !_ctx.hideSessionID)),
                  "fixed-width": ""
                }, null, 8 /* PROPS */, ["icon"]), [
                  [_directive_tooltip, 'Show/Hide your session ID.']
                ]),
                _withDirectives(_createVNode(_component_font_awesome_icon, {
                  class: "clickable",
                  icon: "fa-solid fa-share-from-square",
                  onClick: _ctx.sessionURLToClipboard,
                  "fixed-width": ""
                }, null, 8 /* PROPS */, ["onClick"]), [
                  [_directive_tooltip, 'Copy session link for sharing.']
                ]),
                (_ctx.sessionOwner === _ctx.userID && !_ctx.bracket)
                  ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      id: "bracket-button",
                      class: "clickable",
                      icon: "fa-solid fa-trophy",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.generateBracket(_ctx.teamDraft ? _ctx.BracketType.Team : _ctx.BracketType.Single)))
                    }, null, 512 /* NEED_PATCH */)), [
                      [_directive_tooltip, 'Generate tournament bracket.']
                    ])
                  : (_ctx.bracket)
                    ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        id: "bracket-button",
                        class: "clickable",
                        icon: "fa-solid fa-trophy",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.displayedModal = 'bracket'))
                      }, null, 512 /* NEED_PATCH */)), [
                        [_directive_tooltip, 'Display tournament bracket.']
                      ])
                    : _createCommentVNode("v-if", true),
                (_ctx.sessionOwner === _ctx.userID)
                  ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 2,
                      class: "clickable",
                      icon: "fa-solid fa-user-check",
                      onClick: _ctx.readyCheck
                    }, null, 8 /* PROPS */, ["onClick"])), [
                      [_directive_tooltip, 'Ready Check: Ask everyone in your session if they\'re ready to play.']
                    ])
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("input", {
                type: "file",
                id: "card-list-input-main",
                onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.uploadFile($event, _ctx.parseCustomCardList))),
                style: {"display":"none"},
                accept: ".txt"
              }, null, 32 /* NEED_HYDRATION */),
              _cache[171] || (_cache[171] = _createElementVNode("strong", { class: "remove-below-1400" }, "Card Pool: ", -1 /* CACHED */)),
              (_ctx.useCustomCardList && _ctx.customCardList)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.customCardList.name ?? "Custom Card List"), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_14, [
                      (_ctx.customCardList!.sheets && Object.keys(_ctx.customCardList!.sheets).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _withDirectives(_createVNode(_component_font_awesome_icon, {
                              style: {"padding":"0.25em"},
                              icon: "fa-solid fa-file-alt",
                              class: "clickable blue",
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.displayedModal = 'cardList'))
                            }, null, 512 /* NEED_PATCH */), [
                              [_directive_tooltip, 'Review the card list']
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, "No list loaded")),
                      _createElementVNode("div", _hoisted_17, [
                        (_ctx.sessionOwner === _ctx.userID)
                          ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                              key: 0,
                              style: {"padding":"0.25em"},
                              icon: "fa-solid fa-file-upload"
                            }, null, 512 /* NEED_PATCH */)), [
                              [_directive_tooltip, 'Upload a Custom Card List']
                            ])
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.useCustomCardList = false)),
                        class: "clickable brightred"
                      }, [
                        (_ctx.sessionOwner === _ctx.userID)
                          ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                              key: 0,
                              style: {"padding":"0.25em"},
                              icon: "fa-solid fa-times"
                            }, null, 512 /* NEED_PATCH */)), [
                              [_directive_tooltip, 'Return to official sets.']
                            ])
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass({ disabled: _ctx.sessionOwner != _ctx.userID })
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_set_select, {
                        modelValue: _ctx.setRestriction,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.setRestriction) = $event)),
                        options: _ctx.sets.slice().reverse()
                      }, {
                        beforeList: _withCtx(() => [...(_cache[170] || (_cache[170] = [
                          _createElementVNode("div", {
                            class: "clickable",
                            style: {"text-align":"center","padding":"0.5em","font-size":"0.75em","background-color":"#444"},
                            onclick: "document.querySelector('#card-list-input-main').click()"
                          }, " Upload a Custom Card List... ", -1 /* CACHED */)
                        ]))]),
                        afterList: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "clickable",
                            style: {"text-align":"center","padding":"0.5em","font-size":"0.75em","background-color":"#444"},
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.displayedModal = 'setRestriction'))
                          }, " More sets... ")
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["modelValue", "options"]),
                      _withDirectives((_openBlock(), _createElementBlock("div", {
                        class: "inline clickable",
                        style: {"padding":"0.4em 0.6em"},
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.displayedModal = 'setRestriction'))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-ellipsis-v" })
                      ])), [
                        [_directive_tooltip, 'More sets']
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["inline clickable", { faded: _ctx.ignoreCollections, crossed: _ctx.ignoreCollections }]),
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.ignoreCollections = !_ctx.ignoreCollections))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-book" })
                      ], 2 /* CLASS */)), [
                        [_directive_tooltip, {
									html: true,
									content: `Restrict card pool to Player Collections: <strong>${
										_ctx.ignoreCollections ? 'Disabled' : 'Enabled'
									}</strong>
									<br/>If enabled, card pool will be limited to cards present in all player collections.`,
								}]
                      ])
                    ])
                  ], 2 /* CLASS */))
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["generic-container", { disabled: _ctx.sessionOwner != _ctx.userID }])
            }, [
              _cache[172] || (_cache[172] = _createElementVNode("strong", null, "Draft:", -1 /* CACHED */)),
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["inline", { disabled: _ctx.teamDraft }])
              }, [
                _createElementVNode("label", _hoisted_19, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-robot" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "bots",
                  class: "small-number-input",
                  min: "0",
                  max: Math.max(7, _ctx.maxPlayers - 1),
                  step: "1",
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.bots) = $event))
                }, null, 8 /* PROPS */, _hoisted_20), [
                  [
                    _vModelText,
                    _ctx.bots,
                    void 0,
                    { number: true }
                  ]
                ])
              ], 2 /* CLASS */)), [
                [_directive_tooltip, 'Bots. Use them to draft alone or fill your pod.']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["inline", { disabled: _ctx.tournamentTimer }])
              }, [
                _createElementVNode("label", _hoisted_21, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-stopwatch",
                    size: "lg"
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "timer",
                  class: "small-number-input",
                  min: "0",
                  max: "180",
                  step: "15",
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.maxTimer) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [
                    _vModelText,
                    _ctx.maxTimer,
                    void 0,
                    { number: true }
                  ]
                ])
              ], 2 /* CLASS */)), [
                [_directive_tooltip, 'Pick Timer (sec.). Zero means no timer.']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("span", null, [
                _withDirectives(_createElementVNode("button", {
                  onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.startDraft && _ctx.startDraft(...args))),
                  class: "blue"
                }, "Start", 512 /* NEED_PATCH */), [
                  [_vShow, _ctx.userID === _ctx.sessionOwner]
                ])
              ])), [
                [_directive_tooltip, 'Starts a Draft Session.']
              ])
            ], 2 /* CLASS */),
            _withDirectives(_createElementVNode("span", null, [
              _createVNode(_component_dropdown, {
                class: _normalizeClass({ disabled: _ctx.sessionOwner != _ctx.userID })
              }, {
                handle: _withCtx(() => [...(_cache[173] || (_cache[173] = [
                  _createTextVNode(" Other Game Modes ", -1 /* CACHED */)
                ]))]),
                dropdown: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _cache[174] || (_cache[174] = _createElementVNode("span", { class: "game-modes-cat-title" }, "Draft", -1 /* CACHED */)),
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.startWinstonDraft()))
                      }, "Winston")
                    ])), [
                      [
                        _directive_tooltip,
                        
										'Starts a Winston Draft. This is a draft variant intended for two players, but playable at any number.'
									,
                        void 0,
                        { left: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.startWinchesterDraft()))
                      }, "Winchester")
                    ])), [
                      [
                        _directive_tooltip,
                        
										'Starts a Winchester Draft. This is a draft variant similar to Winston and Rochester draft.'
									,
                        void 0,
                        { left: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.startHousmanDraft()))
                      }, "Housman")
                    ])), [
                      [
                        _directive_tooltip,
                        'Starts a Housman Draft.',
                        void 0,
                        { left: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.startSolomonDraft()))
                      }, "Solomon (2p.)")
                    ])), [
                      [
                        _directive_tooltip,
                        'Starts a Solomon Draft.',
                        void 0,
                        { left: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.startGridDraft()))
                      }, "Grid (2-4p.)")
                    ])), [
                      [
                        _directive_tooltip,
                        
										'Starts a Grid Draft. This is a draft variant for two to four players.'
									,
                        void 0,
                        { left: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.startGlimpseDraft()))
                      }, "Glimpse/Burn")
                    ])), [
                      [
                        _directive_tooltip,
                        
										'Starts a Glimpse Draft. Players also remove cards from the draft each pick.'
									,
                        void 0,
                        { left: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.startRochesterDraft()))
                      }, "Rochester")
                    ])), [
                      [
                        _directive_tooltip,
                        
										'Starts a Rochester Draft. Every players pick from a single booster.'
									,
                        void 0,
                        { left: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.startRotisserieDraft()))
                      }, "Rotisserie")
                    ])), [
                      [
                        _directive_tooltip,
                        
										'Starts a Rotisserie Draft. Each player picks from a single card pool one after the other.'
									,
                        void 0,
                        { left: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.startMinesweeperDraft()))
                      }, "Minesweeper")
                    ])), [
                      [
                        _directive_tooltip,
                        'Starts a Minesweeper Draft.',
                        void 0,
                        { left: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.startSupremeDraft()))
                      }, "Supreme (1p.)")
                    ])), [
                      [
                        _directive_tooltip,
                        'Starts a Solo Supreme Draft.',
                        void 0,
                        { left: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.startSilentAuctionDraft()))
                      }, "Silent Auction")
                    ])), [
                      [
                        _directive_tooltip,
                        'Starts a Silent Auction Draft.',
                        void 0,
                        { left: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _cache[175] || (_cache[175] = _createElementVNode("span", { class: "game-modes-cat-title" }, "Sealed", -1 /* CACHED */)),
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.sealedDialog(false)))
                      }, "Sealed")
                    ])), [
                      [
                        _directive_tooltip,
                        'Distributes boosters to everyone for a sealed session.',
                        void 0,
                        { left: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.sealedDialog(true)))
                      }, "Team Sealed")
                    ])), [
                      [
                        _directive_tooltip,
                        'Starts a Team Sealed.',
                        void 0,
                        { left: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.jumpstartDialog && _ctx.jumpstartDialog(...args)))
                      }, "Jumpstart")
                    ])), [
                      [
                        _directive_tooltip,
                        
										'Distributes two Jumpstart boosters to everyone. Multiple sets are available.'
									,
                        void 0,
                        { left: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.startJumpIn && _ctx.startJumpIn(...args)))
                      }, "Jump In!")
                    ])), [
                      [
                        _directive_tooltip,
                        
										'Distributes two Jump In! boosters to everyone. Multiple sets are available.'
									,
                        void 0,
                        { left: true }
                      ]
                    ])
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["class"])
            ], 512 /* NEED_PATCH */), [
              [_vShow, _ctx.userID === _ctx.sessionOwner]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.displayedModal = 'sessionOptions')),
              class: "setting-button flat"
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-cog" }),
              _cache[176] || (_cache[176] = _createTextVNode(" Settings ", -1 /* CACHED */))
            ])), [
              [_directive_tooltip, 'More session settings']
            ])
          ], 2 /* CLASS */),
          (_ctx.drafting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _cache[180] || (_cache[180] = _createElementVNode("div", { id: "url-remainder" }, [
                  _createElementVNode("span", { class: "draftmancer-wrapper" }, [
                    _createTextVNode("Draftmancer.com"),
                    _createElementVNode("span", { class: "mutated-badge" }, "MUTATED")
                  ])
                ], -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_25, [
                  _createTextVNode(_toDisplayString(_ctx.gameModeName) + " ", 1 /* TEXT */),
                  (_ctx.useCustomCardList && _ctx.customCardList?.name)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, " - " + _toDisplayString(_ctx.customCardList.name), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  (_ctx.sessionOwner === _ctx.userID)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("button", {
                          class: "stop",
                          onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.stopDraft && _ctx.stopDraft(...args)))
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-stop" }),
                          _cache[177] || (_cache[177] = _createTextVNode(" Stop ", -1 /* CACHED */))
                        ]),
                        (_ctx.maxTimer > 0 && !_ctx.draftPaused)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: _normalizeClass(["stop", { 'opaque-disabled': _ctx.waitingForDisconnectedUsers }]),
                              onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.pauseDraft && _ctx.pauseDraft(...args)))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-pause" }),
                              _cache[178] || (_cache[178] = _createTextVNode(" Pause ", -1 /* CACHED */))
                            ], 2 /* CLASS */))
                          : (_ctx.maxTimer > 0 && _ctx.draftPaused)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: _normalizeClass(["confirm", { 'opaque-disabled': _ctx.waitingForDisconnectedUsers }]),
                                onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.resumeDraft && _ctx.resumeDraft(...args)))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-play" }),
                                _cache[179] || (_cache[179] = _createTextVNode(" Resume ", -1 /* CACHED */))
                              ], 2 /* CLASS */))
                            : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Session Players "),
    (_ctx.sessionID !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            (!_ctx.ownerIsPlayer)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-crown",
                    class: "subtle-gold"
                  }),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.sessionOwnerUsername ? _ctx.sessionOwnerUsername : "(Disconnected)"), 1 /* TEXT */),
                  _createElementVNode("div", {
                    class: "chat-bubble",
                    id: 'chat-bubble-' + _ctx.sessionOwner
                  }, null, 8 /* PROPS */, _hoisted_32)
                ])), [
                  [_directive_tooltip, 
						_ctx.sessionOwnerUsername
							? `${_ctx.sessionOwnerUsername} is the session owner.`
							: 'Session owner is disconnected.'
					]
                ])
              : _createCommentVNode("v-if", true),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_33, [
              _cache[181] || (_cache[181] = _createTextVNode(" Players ", -1 /* CACHED */)),
              _cache[182] || (_cache[182] = _createElementVNode("br", null, null, -1 /* CACHED */)),
              _createTextVNode(" (" + _toDisplayString(_ctx.sessionUsers.length) + "/" + _toDisplayString(_ctx.maxPlayers) + ") ", 1 /* TEXT */)
            ])), [
              [_directive_tooltip, 'Maximum players can be adjusted in session settings.']
            ]),
            (!_ctx.drafting)
              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass({
						crossed: !_ctx.randomizeSeatingOrder,
						faded: !_ctx.randomizeSeatingOrder,
						clickable: _ctx.userID === _ctx.sessionOwner,
					}),
                  style: {"margin-right":"0.5em"},
                  onClick: _cache[47] || (_cache[47] = ($event: any) => {if (_ctx.userID === _ctx.sessionOwner) _ctx.randomizeSeatingOrder = !_ctx.randomizeSeatingOrder;})
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-random" })
                ], 2 /* CLASS */)), [
                  [_directive_tooltip, {
						content: `Randomize Seating Order on draft start: <strong>${
							_ctx.randomizeSeatingOrder ? 'Enabled' : 'Disabled'
						}</strong>`,
						html: true,
					}]
                ])
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_34, [
            (!_ctx.drafting)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.sessionOwner === _ctx.userID)
                    ? (_openBlock(), _createBlock(_component_Sortable, {
                        key: `draggable-${_ctx.userOrder.length}`,
                        list: _ctx.userOrder,
                        "item-key": (uid) => uid,
                        options: { animation: 200, disabled: _ctx.userID !== _ctx.sessionOwner },
                        onUpdate: _ctx.changePlayerOrder,
                        class: "player-list",
                        tag: "ul"
                      }, {
                        item: _withCtx(({ element, index }) => [
                          _createVNode(_component_SessionUser, {
                            index: index,
                            user: _ctx.userByID[element],
                            self: _ctx.userID,
                            sessionOwner: _ctx.sessionOwner,
                            pendingReadyCheck: _ctx.pendingReadyCheck,
                            teamDraft: _ctx.teamDraft,
                            useCustomCardList: _ctx.useCustomCardList,
                            ignoreCollections: _ctx.ignoreCollections,
                            canRequestTakeover: _ctx.sessionUsers.length >= 5,
                            onRemovePlayer: _ctx.removePlayer,
                            onSetSessionOwner: _ctx.setSessionOwner,
                            onMovePlayer: _ctx.movePlayer
                          }, null, 8 /* PROPS */, ["index", "user", "self", "sessionOwner", "pendingReadyCheck", "teamDraft", "useCustomCardList", "ignoreCollections", "canRequestTakeover", "onRemovePlayer", "onSetSessionOwner", "onMovePlayer"])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["list", "item-key", "options", "onUpdate"]))
                    : (_openBlock(), _createBlock(_TransitionGroup, {
                        key: 1,
                        tag: "ul",
                        name: "player-list-transition",
                        class: "player-list"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userOrder, (element, index) => {
                            return (_openBlock(), _createBlock(_component_SessionUser, {
                              key: element,
                              index: index,
                              user: _ctx.userByID[element],
                              self: _ctx.userID,
                              sessionOwner: _ctx.sessionOwner,
                              pendingReadyCheck: _ctx.pendingReadyCheck,
                              teamDraft: _ctx.teamDraft,
                              useCustomCardList: _ctx.useCustomCardList,
                              ignoreCollections: _ctx.ignoreCollections,
                              canRequestTakeover: _ctx.sessionUsers.length >= 5,
                              onRequestTakeover: _ctx.requestTakeover
                            }, null, 8 /* PROPS */, ["index", "user", "self", "sessionOwner", "pendingReadyCheck", "teamDraft", "useCustomCardList", "ignoreCollections", "canRequestTakeover", "onRequestTakeover"]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                      }))
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock("ul", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.virtualPlayers, (user, idx) => {
                    return (_openBlock(), _createBlock(_component_Player, {
                      key: user.userID,
                      user: user,
                      userID: _ctx.userID,
                      sessionOwner: _ctx.sessionOwner,
                      passingOrder: _ctx.passingOrder,
                      isCurrentPlayer: _ctx.currentPlayer === user.userID,
                      class: _normalizeClass({
								teama: _ctx.teamDraft && idx % 2 === 0,
								teamb: _ctx.teamDraft && idx % 2 === 1,
								self: _ctx.userID === user.userID,
							}),
                      onRemovePlayer: _ctx.removePlayer,
                      onSetSessionOwner: _ctx.setSessionOwner
                    }, null, 8 /* PROPS */, ["user", "userID", "sessionOwner", "passingOrder", "isCurrentPlayer", "class", "onRemovePlayer", "onSetSessionOwner"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("form", {
              onSubmit: _cache[49] || (_cache[49] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendChatMessage && _ctx.sendChatMessage(...args)), ["prevent"]))
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.currentChatMessage) = $event)),
                placeholder: "Chat with players in your session.",
                maxlength: "255"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.currentChatMessage]
              ])
            ], 32 /* NEED_HYDRATION */),
            _withDirectives(_createVNode(_component_font_awesome_icon, {
              class: "clickable",
              icon: "fa-regular fa-comments",
              onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.displayChatHistory = !_ctx.displayChatHistory))
            }, null, 512 /* NEED_PATCH */), [
              [_directive_tooltip, 'Display chat history.']
            ]),
            (_ctx.displayChatHistory)
              ? (_openBlock(), _createBlock(_component_ChatHistory, {
                  key: 0,
                  onFocusout: _cache[51] || (_cache[51] = ($event: any) => (_ctx.displayChatHistory = false)),
                  messagesHistory: _ctx.messagesHistory,
                  userID: _ctx.userID,
                  sessionOwner: _ctx.sessionOwner,
                  sessionOwnerUsername: _ctx.sessionOwnerUsername,
                  userByID: _ctx.userByID,
                  mutedUsers: _ctx.mutedUsers
                }, null, 8 /* PROPS */, ["messagesHistory", "userID", "sessionOwner", "sessionOwnerUsername", "userByID", "mutedUsers"]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_37, [
      _createCommentVNode(" Draft Controls "),
      _withDirectives(_createElementVNode("div", _hoisted_38, [
        (_ctx.draftState)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_Transition, {
                name: 
							_ctx.draftState.pickNumber > 0
								? `slide-fade-${_ctx.passingOrder === _ctx.PassingOrder.Left ? 'left' : 'right'}`
								: 'booster-fade-in'
						,
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_ctx.gameState === _ctx.GameState.Watching)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          (!_ctx.drafting)
                            ? (_openBlock(), _createElementBlock("h1", _hoisted_41, "Draft Completed"))
                            : (!_ctx.draftPaused)
                              ? (_openBlock(), _createElementBlock("h1", _hoisted_42, "Players are drafting..."))
                              : (_openBlock(), _createElementBlock("h1", _hoisted_43, "Draft Paused")),
                          (_ctx.drafting)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, "Pack #" + _toDisplayString(_ctx.draftState.boosterNumber + 1), 1 /* TEXT */))
                            : (_openBlock(), _createElementBlock("div", _hoisted_45, "Players are now finalizing their decks"))
                        ]),
                        (_ctx.draftLogLive && _ctx.draftLogLive.sessionID === _ctx.sessionID)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              (_openBlock(), _createBlock(_component_DraftLogLiveComponent, {
                                draftlog: _ctx.draftLogLive,
                                show: ['owner', 'delayed', 'everyone'].includes(_ctx.draftLogRecipients),
                                language: _ctx.language,
                                key: _ctx.draftLogLive.time,
                                ref: "draftloglive"
                              }, null, 8 /* PROPS */, ["draftlog", "show", "language"]))
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : (
								(_ctx.gameState === _ctx.GameState.Waiting || _ctx.gameState === _ctx.GameState.Picking) &&
								_ctx.draftState.booster
							)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: `draft-picking-${_ctx.draftState.boosterNumber}-${_ctx.draftState.pickNumber}`,
                          class: _normalizeClass(["container", { disabled: _ctx.waitingForDisconnectedUsers || _ctx.draftPaused }])
                        }, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("h2", null, "Your Booster (" + _toDisplayString(_ctx.draftState.booster.length) + ")", 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("span", null, "Pack #" + _toDisplayString(_ctx.draftState.boosterNumber + 1) + ", Pick #" + _toDisplayString(_ctx.draftState.pickNumber + 1), 1 /* TEXT */),
                              _withDirectives(_createElementVNode("span", {
                                class: _normalizeClass({ redbg: _ctx.pickTimer <= 10 }),
                                id: "chrono"
                              }, [
                                (_openBlock(), _createElementBlock("div", {
                                  class: "timer-icon",
                                  key: `${_ctx.maxTimer}_${_ctx.draftState.boosterNumber}_${_ctx.draftState.pickNumber}`,
                                  style: _normalizeStyle(`--timer-max: ${_ctx.maxTimer}; --timer-current: ${_ctx.pickTimer - 1}`)
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "fa-solid fa-stopwatch",
                                    size: "lg"
                                  }),
                                  _cache[183] || (_cache[183] = _createElementVNode("div", { class: "timer-icon-moving" }, null, -1 /* CACHED */))
                                ], 4 /* STYLE */)),
                                _createElementVNode("span", null, _toDisplayString(_ctx.pickTimer), 1 /* TEXT */)
                              ], 2 /* CLASS */), [
                                [_vShow, _ctx.pickTimer >= 0]
                              ]),
                              (_ctx.gameState == _ctx.GameState.Picking)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_ctx.draftState.skipPick)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          onClick: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.passBooster && _ctx.passBooster(...args)))
                                        }, "Pass Booster"))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          (
													_ctx.selectedCards.length === _ctx.cardsToPick &&
													_ctx.burningCards.length === _ctx.cardsToBurnThisRound
												)
                                            ? (_openBlock(), _createElementBlock("input", {
                                                key: 0,
                                                type: "button",
                                                onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.pickCard())),
                                                value: "Confirm Pick"
                                              }))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_49, [
                                                (_ctx.cardsToPick === 1)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Pick a card"))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_51, " Pick " + _toDisplayString(_ctx.cardsToPick) + " cards (" + _toDisplayString(_ctx.selectedCards.length) + "/" + _toDisplayString(_ctx.cardsToPick) + ") ", 1 /* TEXT */)),
                                                (_ctx.cardsToBurnThisRound === 1)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, " and remove a card from the pool."))
                                                  : (_ctx.cardsToBurnThisRound > 1)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_53, " and remove " + _toDisplayString(_ctx.cardsToBurnThisRound) + " cards from the pool (" + _toDisplayString(_ctx.burningCards.length) + "/" + _toDisplayString(_ctx.cardsToBurnThisRound) + "). ", 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                              ])),
                                          (_ctx.availableOptionalDraftEffects.length > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                                                _cache[185] || (_cache[185] = _createElementVNode("label", { for: "optional-pick-effect" }, "Pick Effect:", -1 /* CACHED */)),
                                                _withDirectives(_createElementVNode("select", {
                                                  id: "optional-pick-effect",
                                                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.selectedOptionalDraftPickEffect) = $event))
                                                }, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableOptionalDraftEffects, (v) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                      value: v,
                                                      key: v.effect
                                                    }, _toDisplayString(v.name) + " (" + _toDisplayString(v.effect) + ") ", 9 /* TEXT, PROPS */, _hoisted_55))
                                                  }), 128 /* KEYED_FRAGMENT */)),
                                                  _cache[184] || (_cache[184] = _createElementVNode("option", { value: undefined }, "Do not use", -1 /* CACHED */))
                                                ], 512 /* NEED_PATCH */), [
                                                  [_vModelSelect, _ctx.selectedOptionalDraftPickEffect]
                                                ])
                                              ]))
                                            : _createCommentVNode("v-if", true),
                                          (_ctx.availableDraftEffects.length > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                                                _cache[187] || (_cache[187] = _createElementVNode("label", { for: "pick-effect" }, "Pick Effect:", -1 /* CACHED */)),
                                                _withDirectives(_createElementVNode("select", {
                                                  id: "pick-effect",
                                                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.selectedUsableDraftEffect) = $event))
                                                }, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableDraftEffects, (v) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                      value: v,
                                                      key: v.effect
                                                    }, _toDisplayString(v.name) + " (" + _toDisplayString(v.effect) + ") ", 9 /* TEXT, PROPS */, _hoisted_57))
                                                  }), 128 /* KEYED_FRAGMENT */)),
                                                  _cache[186] || (_cache[186] = _createElementVNode("option", { value: undefined }, "None", -1 /* CACHED */))
                                                ], 512 /* NEED_PATCH */), [
                                                  [_vModelSelect, _ctx.selectedUsableDraftEffect]
                                                ])
                                              ]))
                                            : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                  ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "fa-solid fa-spinner",
                                      spin: ""
                                    }),
                                    _cache[188] || (_cache[188] = _createTextVNode(" Waiting for other players to pick... ", -1 /* CACHED */))
                                  ], 64 /* STABLE_FRAGMENT */))
                            ]),
                            _createVNode(_component_scale_slider, {
                              modelValue: _ctx.boosterCardScale,
                              "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.boosterCardScale) = $event)),
                              modelModifiers: { number: true }
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _createCommentVNode(" Note: Duration for booster-open can't be determined by Vue since it's composite. Be sure to keep that in sync :) "),
                          _createVNode(_TransitionGroup, {
                            tag: "div",
                            name: _ctx.draftState.pickNumber === 0 ? 'booster-open' : 'booster-cards',
                            class: _normalizeClass(["booster card-container", {
									'booster-waiting': _ctx.gameState === _ctx.GameState.Waiting,
									skipped: _ctx.draftState.skipPick,
								}]),
                            style: _normalizeStyle(`--booster-card-scale: ${_ctx.boosterCardScale};`),
                            duration: 
									_ctx.draftState.pickNumber === 0
										? 500 + 500 + 400 + Math.min(20, _ctx.draftState.booster.length) * 40
										: 0
								,
                            onEnter: _ctx.onEnterBoosterCards,
                            appear: ""
                          }, {
                            default: _withCtx(() => [
                              (_ctx.gameState === _ctx.GameState.Waiting)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                    _withDirectives(_createVNode(_component_font_awesome_icon, {
                                      class: _normalizeClass(["passing-order", {
											'booster-wait-passing-order-left': _ctx.passingOrder === _ctx.PassingOrder.Left,
											'booster-wait-passing-order-right': _ctx.passingOrder === _ctx.PassingOrder.Right,
										}]),
                                      icon: 
											'fa-solid ' +
											(_ctx.passingOrder === _ctx.PassingOrder.Left
												? 'fa-angle-double-left'
												: 'fa-angle-double-right')
										,
                                      size: "sm"
                                    }, null, 8 /* PROPS */, ["class", "icon"]), [
                                      [_vShow, _ctx.draftState.booster.length > 0]
                                    ]),
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "fa-solid fa-spinner",
                                      size: "lg",
                                      spin: ""
                                    }),
                                    _withDirectives(_createVNode(_component_font_awesome_icon, {
                                      class: _normalizeClass(["passing-order", {
											'booster-wait-passing-order-left': _ctx.passingOrder === _ctx.PassingOrder.Left,
											'booster-wait-passing-order-right': _ctx.passingOrder === _ctx.PassingOrder.Right,
										}]),
                                      icon: 
											'fa-solid ' +
											(_ctx.passingOrder === _ctx.PassingOrder.Left
												? 'fa-angle-double-left'
												: 'fa-angle-double-right')
										,
                                      size: "sm"
                                    }, null, 8 /* PROPS */, ["class", "icon"]), [
                                      [_vShow, _ctx.draftState.booster.length > 0]
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draftState.booster, (card, idx) => {
                                return (_openBlock(), _createBlock(_component_booster_card, {
                                  key: `card-booster-${card.uniqueID}`,
                                  card: card,
                                  language: _ctx.language,
                                  canbeburned: _ctx.draftState.burnsThisRound > 0,
                                  burned: _ctx.burningCards.includes(card.uniqueID),
                                  class: _normalizeClass({ selected: _ctx.selectedCards.includes(card.uniqueID) }),
                                  onClick: ($event: any) => (_ctx.draftState.skipPick ? () => {} : _ctx.selectCard($event, card)),
                                  onDblclick: ($event: any) => (_ctx.draftState.skipPick ? () => {} : _ctx.doubleClickCard($event, card)),
                                  onBurn: ($event: any) => (_ctx.draftState.skipPick ? () => {} : _ctx.burnCard($event, card)),
                                  onRestore: ($event: any) => (_ctx.draftState.skipPick ? () => {} : _ctx.restoreCard($event, card)),
                                  draggable: !_ctx.draftState.skipPick,
                                  onDragstart: ($event: any) => (_ctx.draftState.skipPick ? () => {} : _ctx.dragBoosterCard($event, card)),
                                  hasenoughwildcards: _ctx.hasEnoughWildcards(card),
                                  wildcardneeded: _ctx.displayCollectionStatus && _ctx.wildcardCost(card),
                                  botscore: 
										_ctx.gameState !== _ctx.GameState.Waiting &&
										_ctx.botScores &&
										_ctx.botScores.scores &&
										_ctx.displayBotScores
											? _ctx.botScores.scores[idx]
											: null
									,
                                  botpicked: 
										_ctx.gameState !== _ctx.GameState.Waiting &&
										_ctx.botScores &&
										_ctx.displayBotScores &&
										idx === _ctx.botScores.chosenOption
									,
                                  scale: _ctx.boosterCardScale,
                                  renderCommonBackside: _ctx.draftState.pickNumber === 0
                                }, null, 8 /* PROPS */, ["card", "language", "canbeburned", "burned", "class", "onClick", "onDblclick", "onBurn", "onRestore", "draggable", "onDragstart", "hasenoughwildcards", "wildcardneeded", "botscore", "botpicked", "scale", "renderCommonBackside"]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["name", "class", "style", "duration", "onEnter"])
                        ], 2 /* CLASS */))
                      : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["name"]),
              (_ctx.gameState === _ctx.GameState.Reviewing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _cache[190] || (_cache[190] = _createElementVNode("h1", null, "Review Phase", -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_60, [
                      (_openBlock(), _createElementBlock("div", {
                        class: "timer-icon",
                        key: `${_ctx.reviewTimer}_${_ctx.draftState.boosterNumber}_${_ctx.draftState.pickNumber}`,
                        style: _normalizeStyle(`--timer-max: ${_ctx.reviewTimer}; --timer-current: ${_ctx.pickTimer - 1}`)
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "fa-solid fa-stopwatch",
                          size: "lg"
                        }),
                        _cache[189] || (_cache[189] = _createElementVNode("div", { class: "timer-icon-moving" }, null, -1 /* CACHED */))
                      ], 4 /* STYLE */)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.pickTimer), 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        (
						(_ctx.gameState === _ctx.GameState.WinstonPicking || _ctx.gameState === _ctx.GameState.WinstonWaiting) &&
						_ctx.winstonDraftState
					)
          ? (_openBlock(), _createBlock(_component_winston_draft, {
              key: 1,
              class: _normalizeClass(["container", { disabled: _ctx.waitingForDisconnectedUsers || _ctx.draftPaused }]),
              language: _ctx.language,
              userID: _ctx.userID,
              sessionUsers: _ctx.userByID,
              winstonDraftState: _ctx.winstonDraftState,
              onTake: _ctx.winstonDraftTakePile,
              onSkip: _ctx.winstonDraftSkipPile
            }, null, 8 /* PROPS */, ["class", "language", "userID", "sessionUsers", "winstonDraftState", "onTake", "onSkip"]))
          : _createCommentVNode("v-if", true),
        (
						(_ctx.gameState === _ctx.GameState.WinchesterPicking || _ctx.gameState === _ctx.GameState.WinchesterWaiting) &&
						_ctx.winchesterDraftState
					)
          ? (_openBlock(), _createBlock(_component_winchester_draft, {
              key: 2,
              class: _normalizeClass(["container", { disabled: _ctx.waitingForDisconnectedUsers || _ctx.draftPaused }]),
              language: _ctx.language,
              userID: _ctx.userID,
              sessionUsers: _ctx.userByID,
              winchesterDraftState: _ctx.winchesterDraftState,
              onPick: _ctx.winchesterDraftPick
            }, null, 8 /* PROPS */, ["class", "language", "userID", "sessionUsers", "winchesterDraftState", "onPick"]))
          : _createCommentVNode("v-if", true),
        (_ctx.gameState === _ctx.GameState.HousmanDraft && _ctx.housmanDraftState)
          ? (_openBlock(), _createBlock(_component_housman_draft, {
              key: 3,
              class: _normalizeClass(["container", { disabled: _ctx.waitingForDisconnectedUsers || _ctx.draftPaused }]),
              socket: _ctx.socket,
              language: _ctx.language,
              userID: _ctx.userID,
              sessionUsers: _ctx.userByID,
              state: _ctx.housmanDraftState,
              "onUpdate:state": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.housmanDraftState) = $event)),
              onNotifyTurn: _ctx.notifyTurn,
              onAddToDeck: _ctx.addToDeck,
              onEnd: _ctx.housmanDraftEnd
            }, null, 8 /* PROPS */, ["class", "socket", "language", "userID", "sessionUsers", "state", "onNotifyTurn", "onAddToDeck", "onEnd"]))
          : _createCommentVNode("v-if", true),
        (_ctx.gameState === _ctx.GameState.SolomonDraft && _ctx.solomonDraftState)
          ? (_openBlock(), _createBlock(_component_solomon_draft, {
              key: 4,
              class: _normalizeClass(["container", { disabled: _ctx.waitingForDisconnectedUsers || _ctx.draftPaused }]),
              socket: _ctx.socket,
              language: _ctx.language,
              userID: _ctx.userID,
              sessionUsers: _ctx.userByID,
              state: _ctx.solomonDraftState,
              "onUpdate:state": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.solomonDraftState) = $event)),
              onNotifyTurn: _ctx.notifyTurn,
              onAddToDeck: _ctx.addToDeck,
              onEnd: _ctx.solomonDraftEnd
            }, null, 8 /* PROPS */, ["class", "socket", "language", "userID", "sessionUsers", "state", "onNotifyTurn", "onAddToDeck", "onEnd"]))
          : _createCommentVNode("v-if", true),
        (_ctx.gameState === _ctx.GameState.SilentAuctionDraft && _ctx.silentAuctionDraftState)
          ? (_openBlock(), _createBlock(_component_silent_auction_draft, {
              key: 5,
              class: _normalizeClass(["container", { disabled: _ctx.waitingForDisconnectedUsers || _ctx.draftPaused }]),
              socket: _ctx.socket,
              language: _ctx.language,
              userID: _ctx.userID,
              sessionUsers: _ctx.userByID,
              state: _ctx.silentAuctionDraftState,
              "onUpdate:state": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.silentAuctionDraftState) = $event)),
              onAddToDeck: _ctx.addToDeck,
              onEnd: _ctx.silentAuctionDraftEnd
            }, null, 8 /* PROPS */, ["class", "socket", "language", "userID", "sessionUsers", "state", "onAddToDeck", "onEnd"]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Grid Draft "),
        (
						(_ctx.gameState === _ctx.GameState.GridPicking || _ctx.gameState === _ctx.GameState.GridWaiting) && _ctx.gridDraftState
					)
          ? (_openBlock(), _createElementBlock("div", {
              key: 6,
              class: _normalizeClass({ disabled: _ctx.waitingForDisconnectedUsers || _ctx.draftPaused })
            }, [
              _createElementVNode("div", _hoisted_61, [
                _cache[192] || (_cache[192] = _createElementVNode("h2", null, "Grid Draft", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("span", null, " Pack #" + _toDisplayString(Math.min(
										Math.floor(_ctx.gridDraftState.round / _ctx.sessionUsers.length) + 1,
										_ctx.gridDraftState.boosterCount
									)) + "/" + _toDisplayString(_ctx.gridDraftState.boosterCount), 1 /* TEXT */),
                  _createElementVNode("span", null, [
                    (_ctx.userID === _ctx.gridDraftState.currentPlayer)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-exclamation-circle" }),
                          _cache[191] || (_cache[191] = _createTextVNode(" It's your turn! Pick a column or a row. ", -1 /* CACHED */))
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_ctx.gridDraftState.currentPlayer === null)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (
											Math.floor(_ctx.gridDraftState.round / _ctx.sessionUsers.length) + 1 >
											_ctx.gridDraftState.boosterCount
										)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" This was the last booster! Let me push these booster wrappers off the table... ")
                                ], 64 /* STABLE_FRAGMENT */))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("Advancing to the next booster...")
                                ], 64 /* STABLE_FRAGMENT */))
                          ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "fa-solid fa-spinner",
                              spin: ""
                            }),
                            _createTextVNode(" Waiting for " + _toDisplayString(_ctx.gridDraftState.currentPlayer in _ctx.userByID
											? _ctx.userByID[_ctx.gridDraftState.currentPlayer].userName
											: "(Disconnected)") + "... ", 1 /* TEXT */)
                          ], 64 /* STABLE_FRAGMENT */))
                  ])
                ])
              ]),
              _createVNode(_component_grid_draft, {
                state: _ctx.gridDraftState,
                picking: _ctx.userID === _ctx.gridDraftState.currentPlayer,
                onPick: _ctx.gridDraftPick
              }, null, 8 /* PROPS */, ["state", "picking", "onPick"])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Rochester Draft "),
        (
						(_ctx.gameState === _ctx.GameState.RochesterPicking || _ctx.gameState === _ctx.GameState.RochesterWaiting) &&
						_ctx.rochesterDraftState
					)
          ? (_openBlock(), _createElementBlock("div", {
              key: 7,
              class: _normalizeClass(["rochester-container", { disabled: _ctx.waitingForDisconnectedUsers || _ctx.draftPaused }])
            }, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _cache[194] || (_cache[194] = _createElementVNode("h2", null, "Rochester Draft", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("span", null, " Pack #" + _toDisplayString(_ctx.rochesterDraftState.boosterNumber + 1) + "/" + _toDisplayString(_ctx.rochesterDraftState.boosterCount) + ", Pick #" + _toDisplayString(_ctx.rochesterDraftState.pickNumber + 1), 1 /* TEXT */),
                    (_ctx.userID === _ctx.rochesterDraftState.currentPlayer)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("span", null, [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-exclamation-circle" }),
                            _cache[193] || (_cache[193] = _createTextVNode(" It's your turn! Pick a card. ", -1 /* CACHED */))
                          ]),
                          _createElementVNode("span", null, [
                            (_ctx.selectedCards.length === _ctx.cardsToPick)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  type: "button",
                                  onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.pickCard())),
                                  value: "Confirm Pick"
                                }))
                              : _createCommentVNode("v-if", true)
                          ])
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock("span", _hoisted_66, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-spinner",
                            spin: ""
                          }),
                          _createTextVNode(" Waiting for " + _toDisplayString(_ctx.rochesterDraftState.currentPlayer in _ctx.userByID
												? _ctx.userByID[_ctx.rochesterDraftState.currentPlayer].userName
												: "(Disconnected)") + "... ", 1 /* TEXT */)
                        ]))
                  ]),
                  _createVNode(_component_scale_slider, {
                    modelValue: _ctx.boosterCardScale,
                    "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.boosterCardScale) = $event)),
                    modelModifiers: { number: true }
                  }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _createVNode(_Transition, {
                  name: "fade",
                  mode: "out-in",
                  appear: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_TransitionGroup, {
                      name: "booster-cards",
                      tag: "div",
                      class: "booster card-container",
                      style: _normalizeStyle(`--booster-card-scale: ${_ctx.boosterCardScale};`),
                      key: _ctx.rochesterDraftState.boosterNumber
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rochesterDraftState.booster, (card) => {
                          return (_openBlock(), _createBlock(_component_booster_card, {
                            key: `card-booster-${card.uniqueID}`,
                            card: card,
                            language: _ctx.language,
                            canbeburned: false,
                            class: _normalizeClass({
										selected:
											_ctx.userID === _ctx.rochesterDraftState.currentPlayer &&
											_ctx.selectedCards.includes(card.uniqueID),
									}),
                            onClick: ($event: any) => {if (_ctx.userID === _ctx.rochesterDraftState.currentPlayer) _ctx.selectCard($event, card);},
                            onDblclick: ($event: any) => {
										if (_ctx.userID === _ctx.rochesterDraftState.currentPlayer) _ctx.doubleClickCard($event, card);
									},
                            draggable: _ctx.userID === _ctx.rochesterDraftState.currentPlayer,
                            onDragstart: ($event: any) => {
										if (_ctx.userID === _ctx.rochesterDraftState.currentPlayer) _ctx.dragBoosterCard($event, card);
									},
                            hasenoughwildcards: _ctx.hasEnoughWildcards(card),
                            wildcardneeded: _ctx.displayCollectionStatus && _ctx.wildcardCost(card),
                            scale: _ctx.boosterCardScale
                          }, null, 8 /* PROPS */, ["card", "language", "class", "onClick", "onDblclick", "draggable", "onDragstart", "hasenoughwildcards", "wildcardneeded", "scale"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["style"]))
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _createVNode(_component_pick_summary, {
                picks: _ctx.rochesterDraftState.lastPicks
              }, null, 8 /* PROPS */, ["picks"])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (
							_ctx.draftPaused && !_ctx.waitingForDisconnectedUsers && !(_ctx.userID === _ctx.sessionOwner && !_ctx.ownerIsPlayer)
						)
              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _cache[196] || (_cache[196] = _createElementVNode("div", {
                      class: "swal2-icon swal2-warning swal2-icon-show",
                      style: {"display":"flex"}
                    }, [
                      _createElementVNode("div", { class: "swal2-icon-content" }, "!")
                    ], -1 /* CACHED */)),
                    _cache[197] || (_cache[197] = _createElementVNode("h1", null, "Draft Paused", -1 /* CACHED */)),
                    (_ctx.userID === _ctx.sessionOwner)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                          _createElementVNode("button", {
                            class: "confirm",
                            onClick: _cache[62] || (_cache[62] = 
//@ts-ignore
(...args) => (_ctx.resumeDraft && _ctx.resumeDraft(...args)))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-play" }),
                            _cache[195] || (_cache[195] = _createTextVNode(" Resume ", -1 /* CACHED */))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" Wait for the session owner to resume. ")
                        ], 64 /* STABLE_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }),
        _createCommentVNode(" Minesweeper Draft "),
        (
						(_ctx.gameState === _ctx.GameState.MinesweeperPicking || _ctx.gameState === _ctx.GameState.MinesweeperWaiting) &&
						_ctx.minesweeperDraftState
					)
          ? (_openBlock(), _createBlock(_component_minesweeper_draft, {
              key: 8,
              class: _normalizeClass({ disabled: _ctx.waitingForDisconnectedUsers || _ctx.draftPaused }),
              state: _ctx.minesweeperDraftState,
              currentPlayerUsername: 
						_ctx.minesweeperDraftState.currentPlayer in _ctx.userByID
							? _ctx.userByID[_ctx.minesweeperDraftState.currentPlayer].userName
							: _ctx.minesweeperDraftState.currentPlayer == ''
								? ''
								: '(Disconnected)'
					,
              picking: _ctx.userID === _ctx.minesweeperDraftState.currentPlayer,
              onPick: _ctx.minesweeperDraftPick
            }, null, 8 /* PROPS */, ["class", "state", "currentPlayerUsername", "picking", "onPick"]))
          : _createCommentVNode("v-if", true),
        (_ctx.gameState === _ctx.GameState.TeamSealed)
          ? (_openBlock(), _createBlock(_component_team_sealed, {
              key: 9,
              language: _ctx.language,
              state: _ctx.teamSealedState,
              users: _ctx.sessionUsers,
              onPick: _ctx.teamSealedPick
            }, null, 8 /* PROPS */, ["language", "state", "users", "onPick"]))
          : _createCommentVNode("v-if", true),
        (_ctx.gameState === _ctx.GameState.RotisserieDraft)
          ? (_openBlock(), _createBlock(_component_rotisserie_draft, {
              key: 10,
              language: _ctx.language,
              state: _ctx.rotisserieDraftState,
              users: _ctx.sessionUsers,
              userID: _ctx.userID,
              onPick: _ctx.rotisserieDraftPick
            }, null, 8 /* PROPS */, ["language", "state", "users", "userID", "onPick"]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Disconnected User(s) Modal "),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.waitingForDisconnectedUsers)
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _cache[198] || (_cache[198] = _createElementVNode("div", {
                      class: "swal2-icon swal2-warning swal2-icon-show",
                      style: {"display":"flex"}
                    }, [
                      _createElementVNode("div", { class: "swal2-icon-content" }, "!")
                    ], -1 /* CACHED */)),
                    _cache[199] || (_cache[199] = _createElementVNode("h1", null, "Player(s) disconnected", -1 /* CACHED */)),
                    (
									_ctx.winstonDraftState ||
									_ctx.winchesterDraftState ||
									_ctx.housmanDraftState ||
									_ctx.gridDraftState ||
									_ctx.rochesterDraftState ||
									_ctx.rotisserieDraftState ||
									_ctx.minesweeperDraftState
								)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(`Wait for ${_ctx.disconnectedUserNames} to come back...`), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          (_ctx.userID === _ctx.sessionOwner)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(`Wait for ${_ctx.disconnectedUserNames} to come back, or...`) + " ", 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_74, [
                                  _createElementVNode("button", {
                                    onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.socket.emit('replaceDisconnectedPlayers'))),
                                    class: "stop"
                                  }, " Replace them by bot(s) ")
                                ])
                              ], 64 /* STABLE_FRAGMENT */))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(`Wait for ${_ctx.disconnectedUserNames} to come back or for the owner to replace them by bot(s).`), 1 /* TEXT */)
                              ], 64 /* STABLE_FRAGMENT */))
                        ]))
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ], 512 /* NEED_PATCH */), [
        [_vShow, _ctx.drafting || _ctx.gameState === _ctx.GameState.Watching]
      ]),
      (_ctx.gameState === _ctx.GameState.Brewing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
            (_ctx.managed)
              ? (_openBlock(), _createElementBlock("a", _hoisted_76, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-arrow-left" }),
                  _cache[200] || (_cache[200] = _createTextVNode(" Back to Draft Queue ", -1 /* CACHED */))
                ]))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.gameState = _ctx.GameState.None))
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-arrow-left" }),
                  _cache[201] || (_cache[201] = _createTextVNode(" Back to Home ", -1 /* CACHED */))
                ]))
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Brewing controls (Deck & Sideboard) "),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["deck-and-sideboard-container", { 'fixed-deck-and-sideboard-container': _ctx.displayFixedDeck }]),
        ref: "fixedDeckContainer"
      }, [
        (_ctx.displayFixedDeck)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "deck-and-sideboard-container-resize-bar",
              onMousedown: _cache[65] || (_cache[65] = 
//@ts-ignore
(...args) => (_ctx.fixedDeckMouseDown && _ctx.fixedDeckMouseDown(...args)))
            }, null, 32 /* NEED_HYDRATION */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_77, [
          (_ctx.displayFixedDeck)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.fixedDeck = false)),
                class: "fixed-deck-and-sideboard-close clickable",
                icon: "fa-solid fa-times",
                size: "lg",
                "aria-hidden": "true"
              }))
            : _createCommentVNode("v-if", true),
          _withDirectives(_createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _createVNode(_component_card_pool, {
                cards: _ctx.deck,
                language: _ctx.language,
                onCardClick: _ctx.deckToSideboard,
                readOnly: false,
                onCardDragAdd: _ctx.onDeckDragAdd,
                onCardDragRemove: _ctx.onDeckDragRemove,
                ref: "deckDisplay",
                group: "deck",
                onDragover: _cache[76] || (_cache[76] = ($event: any) => (_ctx.allowBoosterCardDrop($event))),
                onDragleave: _cache[77] || (_cache[77] = ($event: any) => (_ctx.onDragLeave($event))),
                onDrop: _cache[78] || (_cache[78] = ($event: any) => (_ctx.dropBoosterCard($event))),
                cardConditionalClasses: _ctx.cardConditionalClasses,
                backupKey: "deck"
              }, {
                title: _withCtx(() => [
                  _createTextVNode(" Deck (" + _toDisplayString(_ctx.deck.length), 1 /* TEXT */),
                  _withDirectives((_openBlock(), _createElementBlock("span", null, [
                    _createTextVNode(" + " + _toDisplayString(_ctx.totalLands), 1 /* TEXT */)
                  ])), [
                    [_vShow, _ctx.gameState == _ctx.GameState.Brewing && _ctx.totalLands > 0],
                    [_directive_tooltip, 'Added basics on export (Not shown in decklist below).']
                  ]),
                  _cache[202] || (_cache[202] = _createTextVNode(") ", -1 /* CACHED */))
                ]),
                controls: _withCtx(() => [
                  (_ctx.deck.length > 0)
                    ? (_openBlock(), _createBlock(_component_ExportDropdown, {
                        key: 0,
                        language: _ctx.language,
                        deck: _ctx.deck,
                        sideboard: _ctx.sideboard,
                        options: {
											lands: _ctx.lands,
											preferredBasics: _ctx.preferredBasics,
											sideboardBasics: _ctx.sideboardBasics,
										}
                      }, null, 8 /* PROPS */, ["language", "deck", "sideboard", "options"]))
                    : _createCommentVNode("v-if", true),
                  _withDirectives((_openBlock(), _createElementBlock("div", {
                    class: "clickable",
                    style: {"display":"flex"},
                    onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.displayedModal = 'sampleHand'))
                  }, [...(_cache[203] || (_cache[203] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      width: "24px",
                      height: "24px"
                    }, null, -1 /* CACHED */)
                  ]))])), [
                    [_directive_tooltip, 'Draw a Sample Hand']
                  ]),
                  _createElementVNode("div", {
                    class: "deck-stat-container clickable",
                    onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.displayedModal = 'deckStats'))
                  }, [
                    _withDirectives(_createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-chart-pie",
                      size: "lg"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _directive_tooltip,
                        'Deck Statistics',
                        void 0,
                        { top: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_80, [
                      _createTextVNode(_toDisplayString(_ctx.deckCreatureCount) + " ", 1 /* TEXT */),
                      _cache[204] || (_cache[204] = _createElementVNode("img", { src: _imports_3 }, null, -1 /* CACHED */))
                    ])), [
                      [_directive_tooltip, 'Creatures in deck']
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_81, [
                      _createTextVNode(_toDisplayString(_ctx.deckLandCount) + " ", 1 /* TEXT */),
                      _cache[205] || (_cache[205] = _createElementVNode("img", { src: _imports_4 }, null, -1 /* CACHED */))
                    ])), [
                      [_directive_tooltip, 'Lands in deck']
                    ])
                  ]),
                  (_ctx.gameState === _ctx.GameState.Brewing)
                    ? (_openBlock(), _createBlock(_component_land_control, {
                        key: 1,
                        lands: _ctx.lands,
                        autoland: _ctx.autoLand,
                        "onUpdate:autoland": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.autoLand) = $event)),
                        targetDeckSize: _ctx.targetDeckSize,
                        "onUpdate:targetDeckSize": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.targetDeckSize) = $event)),
                        sideboardBasics: _ctx.sideboardBasics,
                        "onUpdate:sideboardBasics": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.sideboardBasics) = $event)),
                        preferredBasics: _ctx.preferredBasics,
                        "onUpdate:preferredBasics": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.preferredBasics) = $event)),
                        otherbasics: _ctx.basicsInDeck,
                        onRemovebasics: _ctx.removeBasicsFromDeck,
                        "onUpdate:lands": _cache[73] || (_cache[73] = (c, n) => (_ctx.lands[c] = n))
                      }, null, 8 /* PROPS */, ["lands", "autoland", "targetDeckSize", "sideboardBasics", "preferredBasics", "otherbasics", "onRemovebasics"]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.displayWildcardInfo && _ctx.neededWildcards)
                    ? _withDirectives((_openBlock(), _createBlock(_component_dropdown, {
                        key: 2,
                        minwidth: "8em"
                      }, {
                        handle: _withCtx(() => [
                          _createElementVNode("span", _hoisted_82, [
                            _createElementVNode("span", {
                              class: _normalizeClass({
														yellow:
															_ctx.collectionInfos.wildcards &&
															_ctx.collectionInfos.wildcards['rare'] <
																(_ctx.neededWildcards!.main?.rare ?? 0),
													})
                            }, [
                              _cache[206] || (_cache[206] = _createElementVNode("img", {
                                class: "wildcard-icon",
                                src: `img/wc_rare.webp`
                              }, null, -1 /* CACHED */)),
                              _createTextVNode(" " + _toDisplayString(_ctx.neededWildcards!.main?.rare ?? 0), 1 /* TEXT */)
                            ], 2 /* CLASS */),
                            _createElementVNode("span", {
                              class: _normalizeClass({
														yellow:
															_ctx.collectionInfos.wildcards &&
															_ctx.collectionInfos.wildcards['mythic'] <
																(_ctx.neededWildcards!.main?.mythic ?? 0),
													})
                            }, [
                              _cache[207] || (_cache[207] = _createElementVNode("img", {
                                class: "wildcard-icon",
                                src: `img/wc_mythic.webp`
                              }, null, -1 /* CACHED */)),
                              _createTextVNode(" " + _toDisplayString(_ctx.neededWildcards!.main?.mythic ?? 0), 1 /* TEXT */)
                            ], 2 /* CLASS */)
                          ])
                        ]),
                        dropdown: _withCtx(() => [
                          _createElementVNode("table", _hoisted_83, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.neededWildcards.main, (value, rarity) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: rarity,
                                class: _normalizeClass({
														yellow:
															_ctx.collectionInfos.wildcards &&
															_ctx.collectionInfos.wildcards[rarity] < value,
													})
                              }, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("img", {
                                    class: "wildcard-icon",
                                    src: `img/wc_${rarity}.webp`
                                  }, null, 8 /* PROPS */, _hoisted_84)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(value), 1 /* TEXT */),
                                _createElementVNode("td", null, "(" + _toDisplayString(_ctx.neededWildcards!.side?.[rarity] ?? 0) + ")", 1 /* TEXT */),
                                (_ctx.collectionInfos && _ctx.collectionInfos.wildcards)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _cache[208] || (_cache[208] = _createElementVNode("td", { style: {"font-size":"0.75em","color":"#bbb"} }, "/", -1 /* CACHED */)),
                                      _createElementVNode("td", _hoisted_85, _toDisplayString(_ctx.collectionInfos.wildcards[rarity]), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : _createCommentVNode("v-if", true)
                              ], 2 /* CLASS */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          (_ctx.collectionInfos.vaultProgress)
                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_86, [
                                _cache[209] || (_cache[209] = _createElementVNode("img", {
                                  src: _imports_5,
                                  style: {"height":"1.5rem"}
                                }, null, -1 /* CACHED */)),
                                _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.collectionInfos.vaultProgress) + "%", 1 /* TEXT */)
                              ])), [
                                [
                                  _directive_tooltip,
                                  
													'Vault Progress. For every 100% you\'ll receive 1 mythic, 2 rare and 3 uncommon wildcards when opened.'
												,
                                  void 0,
                                  { right: true }
                                ]
                              ])
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      })), [
                        [
                          _directive_tooltip,
                          {
											content: `Wildcards needed to craft this deck.<br>Main Deck (Sideboard) / Available`,
											html: true,
										},
                          void 0,
                          { top: true }
                        ]
                      ])
                    : _createCommentVNode("v-if", true),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_88, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "Search...",
                      "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.deckFilter) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.deckFilter]
                    ]),
                    _createElementVNode("span", {
                      onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.deckFilter = ''))
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-times-circle" })
                    ])
                  ])), [
                    [
                      _directive_tooltip,
                      
											'Quick search for English card names and types in your deck/sideboard.'
										,
                      void 0,
                      { top: true }
                    ]
                  ])
                ]),
                "right-controls": _withCtx(() => [
                  _createElementVNode("div", _hoisted_89, [
                    _withDirectives(_createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-arrow-right-arrow-left",
                      class: "clickable",
                      onClick: _ctx.swapDeckAndSideboard
                    }, null, 8 /* PROPS */, ["onClick"]), [
                      [_directive_tooltip, 'Swap deck and sideboard']
                    ]),
                    _withDirectives(_createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-arrow-right-to-bracket",
                      class: _normalizeClass(["clickable", { disabled: _ctx.sideboard.length === 0 }]),
                      flip: "horizontal",
                      onClick: _ctx.moveAllToDeck
                    }, null, 8 /* PROPS */, ["class", "onClick"]), [
                      [_directive_tooltip, 'Move all cards from sideboard to deck']
                    ]),
                    _withDirectives(_createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-arrow-right-from-bracket",
                      class: _normalizeClass(["clickable", { disabled: _ctx.deck.length === 0 }]),
                      onClick: _ctx.moveAllToSideboard
                    }, null, 8 /* PROPS */, ["class", "onClick"]), [
                      [_directive_tooltip, 'Move all cards from deck to sideboard']
                    ])
                  ])
                ]),
                empty: _withCtx(() => [...(_cache[210] || (_cache[210] = [
                  _createElementVNode("h3", null, "Your deck is currently empty!", -1 /* CACHED */),
                  _createElementVNode("p", null, "Click on cards in your sideboard to move them here.", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["cards", "language", "onCardClick", "onCardDragAdd", "onCardDragRemove", "cardConditionalClasses"])
            ]),
            _createCommentVNode(" Collapsed Sideboard "),
            (
								_ctx.collapseSideboard &&
								((_ctx.sideboard != undefined && _ctx.sideboard.length > 0) ||
									(_ctx.drafting && _ctx.gameState !== _ctx.GameState.Watching) ||
									_ctx.gameState == _ctx.GameState.Brewing)
							)
              ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("h2", null, [
                      _cache[211] || (_cache[211] = _createTextVNode(" Sideboard ", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_92, "(" + _toDisplayString(_ctx.sideboard.length) + ")", 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_93, [
                      _withDirectives(_createVNode(_component_font_awesome_icon, {
                        class: "clickable",
                        icon: "fa-regular fa-window-maximize",
                        onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.collapseSideboard = false))
                      }, null, 512 /* NEED_PATCH */), [
                        [_directive_tooltip, 'Maximize sideboard']
                      ])
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "card-container",
                    onDragover: _cache[81] || (_cache[81] = ($event: any) => (_ctx.allowBoosterCardDrop($event))),
                    onDragleave: _cache[82] || (_cache[82] = ($event: any) => (_ctx.onDragLeave($event))),
                    onDrop: _cache[83] || (_cache[83] = ($event: any) => (_ctx.dropBoosterCard($event, { toSideboard: true })))
                  }, [
                    (_openBlock(), _createBlock(_component_Sortable, {
                      key: `collapsed-sideboard-col-${_ctx.sideboard.map((c) => c.uniqueID).join('-')}`,
                      class: "card-column drag-column",
                      list: _ctx.sideboard,
                      "item-key": "uniqueID",
                      options: {
										group: 'deck',
										animation: '200',
										ghostClass: 'ghost',
										multiDrag: true,
										selectedClass: 'multi-drag-selected',
										multiDragKey: 'ctrl',
									},
                      onAdd: _ctx.onCollapsedSideDragAdd,
                      onRemove: _ctx.onCollapsedSideDragRemove,
                      onUpdate: _cache[80] || (_cache[80] = ($event: any) => (_ctx.sortableUpdate($event, _ctx.sideboard)))
                    }, {
                      item: _withCtx(({ element }) => [
                        _createVNode(_component_card, {
                          card: element,
                          language: _ctx.language,
                          onClick: _withModifiers(($event: any) => (_ctx.sideboardToDeck($event, element)), ["exact"]),
                          conditionalClasses: _ctx.cardConditionalClasses
                        }, null, 8 /* PROPS */, ["card", "language", "onClick", "conditionalClasses"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["list", "onAdd", "onRemove"]))
                  ], 32 /* NEED_HYDRATION */)
                ]))
              : _createCommentVNode("v-if", true)
          ], 512 /* NEED_PATCH */), [
            [_vShow, 
							(_ctx.deck !== undefined && _ctx.deck.length > 0) ||
							(_ctx.drafting && _ctx.gameState !== _ctx.GameState.Watching) ||
							_ctx.gameState === _ctx.GameState.Brewing
						]
          ]),
          _createCommentVNode(" Full size Sideboard "),
          _withDirectives(_createElementVNode("div", _hoisted_94, [
            _createVNode(_component_card_pool, {
              cards: _ctx.sideboard,
              language: _ctx.language,
              onCardClick: _ctx.sideboardToDeck,
              readOnly: false,
              onCardDragAdd: _ctx.onSideDragAdd,
              onCardDragRemove: _ctx.onSideDragRemove,
              ref: "sideboardDisplay",
              group: "deck",
              onDragover: _cache[85] || (_cache[85] = ($event: any) => (_ctx.allowBoosterCardDrop($event))),
              onDragleave: _cache[86] || (_cache[86] = ($event: any) => (_ctx.onDragLeave($event))),
              onDrop: _cache[87] || (_cache[87] = ($event: any) => (_ctx.dropBoosterCard($event, { toSideboard: true }))),
              cardConditionalClasses: _ctx.cardConditionalClasses,
              backupKey: "sideboard"
            }, {
              title: _withCtx(() => [
                _createTextVNode(" Sideboard (" + _toDisplayString(_ctx.sideboard.length) + ") ", 1 /* TEXT */)
              ]),
              "right-controls": _withCtx(() => [
                _withDirectives(_createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-columns",
                  class: "clickable",
                  onClick: _cache[84] || (_cache[84] = ($event: any) => (_ctx.collapseSideboard = true))
                }, null, 512 /* NEED_PATCH */), [
                  [_directive_tooltip, 'Minimize sideboard']
                ])
              ]),
              empty: _withCtx(() => [...(_cache[212] || (_cache[212] = [
                _createElementVNode("h3", null, "Your sideboard is currently empty!", -1 /* CACHED */),
                _createElementVNode("p", null, "Click on cards in your deck to move them here.", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["cards", "language", "onCardClick", "onCardDragAdd", "onCardDragRemove", "cardConditionalClasses"])
          ], 512 /* NEED_PATCH */), [
            [_vShow, 
							!_ctx.collapseSideboard &&
							((_ctx.sideboard != undefined && _ctx.sideboard.length > 0) ||
								(_ctx.drafting && _ctx.gameState !== _ctx.GameState.Watching) ||
								_ctx.gameState == _ctx.GameState.Brewing)
						]
          ])
        ])
      ], 2 /* CLASS */), [
        [_vShow, _ctx.displayDeckAndSideboard]
      ]),
      (_ctx.gameState === _ctx.GameState.None)
        ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
            (_ctx.page === 'draftqueue')
              ? (_openBlock(), _createBlock(_component_DraftQueue, {
                  key: 0,
                  socket: _ctx.socket
                }, null, 8 /* PROPS */, ["socket"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.previousDeck)
                    ? _withDirectives((_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[88] || (_cache[88] = 
//@ts-ignore
(...args) => (_ctx.loadPreviousDeck && _ctx.loadPreviousDeck(...args))),
                        class: "reload-deck-button"
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'rotate-left'] }),
                        _cache[213] || (_cache[213] = _createTextVNode(" Reload last deck ", -1 /* CACHED */))
                      ])), [
                        [_directive_tooltip, `Reload deck of the last played session from your game logs.`]
                      ])
                    : _createCommentVNode("v-if", true),
                  _cache[244] || (_cache[244] = _createElementVNode("h1", null, [
                    _createTextVNode(" Welcome to "),
                    _createElementVNode("span", { class: "draftmancer-wrapper" }, [
                      _createTextVNode("Draftmancer.com"),
                      _createElementVNode("span", { class: "mutated-badge" }, "MUTATED")
                    ]),
                    _createTextVNode("! ")
                  ], -1 /* CACHED */)),
                  _cache[245] || (_cache[245] = _createElementVNode("p", { class: "important" }, " Draft with other players and export your resulting deck to Magic: The Gathering Arena to play with them, in pod! ", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_96, [
                    _cache[214] || (_cache[214] = _createElementVNode("div", null, [
                      _createElementVNode("a", { href: "/draftqueue" }, [
                        _createElementVNode("div", { class: "draft-queue-banner" }, [
                          _createElementVNode("img", {
                            src: _imports_6,
                            alt: "Practice Teenage Mutant Ninja Turtles with human players right now in the Draft Queue!",
                            width: "500",
                            height: "260"
                          })
                        ])
                      ]),
                      _createCommentVNode("\n\t\t\t\t\t\t\t<div class=\"section-title\">\n\t\t\t\t\t\t\t\t<h2>Quick Start</h2>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"welcome-section welcome-alt\">\n\t\t\t\t\t\t\t\tThere are multiple ways to get started with Draftmancer:\n\t\t\t\t\t\t\t\t<ul class=\"quick-start-list\">\n\t\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t\tPratice the latest sets with other players in the\n\t\t\t\t\t\t\t\t\t\t<a href=\"/draftqueue\">Draft Queue</a>!\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t\tDraft with bots by selecting a set and clicking \"<span\n\t\t\t\t\t\t\t\t\t\t\t@click=\"startDraft\"\n\t\t\t\t\t\t\t\t\t\t\t:class=\"{ link: userID === sessionOwner }\"\n\t\t\t\t\t\t\t\t\t\t\tstyle=\"font-variant: small-caps\"\n\t\t\t\t\t\t\t\t\t\t\t>Start</span\n\t\t\t\t\t\t\t\t\t\t>\" on top of the page.\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t<li>Join one of the featured communities and participate in events.</li>\n\t\t\t\t\t\t\t\t\t<li>Tinker with the settings and organize your own events!</li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t")
                    ], -1 /* CACHED */)),
                    _createVNode(_component_Communities)
                  ]),
                  _createElementVNode("div", _hoisted_97, [
                    _createElementVNode("div", _hoisted_98, [
                      _cache[215] || (_cache[215] = _createElementVNode("div", { class: "section-title" }, [
                        _createElementVNode("h2", null, "News")
                      ], -1 /* CACHED */)),
                      _createVNode(_component_news, {
                        class: "welcome-section",
                        onMoreSets: _cache[89] || (_cache[89] = ($event: any) => (_ctx.displayedModal = 'setRestriction'))
                      })
                    ]),
                    _createElementVNode("div", _hoisted_99, [
                      _cache[225] || (_cache[225] = _createElementVNode("div", { class: "section-title" }, [
                        _createElementVNode("h2", null, "Help")
                      ], -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_100, [
                        _createElementVNode("div", _hoisted_101, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", {
                              class: "link",
                              onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.displayedModal = 'gettingStarted'))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-rocket" }),
                              _cache[216] || (_cache[216] = _createTextVNode(" Get Started ", -1 /* CACHED */))
                            ]),
                            _cache[217] || (_cache[217] = _createTextVNode(" guide ", -1 /* CACHED */))
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("span", {
                              class: "link",
                              onClick: _cache[91] || (_cache[91] = ($event: any) => (_ctx.displayedModal = 'help'))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-info-circle" }),
                              _cache[218] || (_cache[218] = _createTextVNode(" FAQ / Settings Description ", -1 /* CACHED */))
                            ])
                          ])
                        ]),
                        _cache[220] || (_cache[220] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _cache[221] || (_cache[221] = _createTextVNode(" For any question/bug report/feature request you can email to ", -1 /* CACHED */)),
                        _cache[222] || (_cache[222] = _createElementVNode("a", { href: "mailto:dev@draftmancer.com" }, "dev@draftmancer.com", -1 /* CACHED */)),
                        _cache[223] || (_cache[223] = _createTextVNode(" or join the ", -1 /* CACHED */)),
                        _createElementVNode("a", _hoisted_102, [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-brands fa-discord" }),
                          _cache[219] || (_cache[219] = _createTextVNode(" Draftmancer Discord ", -1 /* CACHED */))
                        ]),
                        _cache[224] || (_cache[224] = _createTextVNode(". ", -1 /* CACHED */))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("h2", null, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-mug-hot",
                            "aria-hidden": "true"
                          }),
                          _cache[226] || (_cache[226] = _createTextVNode(" Buy me a Coffee ", -1 /* CACHED */))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("div", null, [
                          _cache[231] || (_cache[231] = _createTextVNode(" Hello there!", -1 /* CACHED */)),
                          _cache[232] || (_cache[232] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                          _cache[233] || (_cache[233] = _createTextVNode(" I hope you're enjoying using Draftmancer!", -1 /* CACHED */)),
                          _cache[234] || (_cache[234] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                          _cache[235] || (_cache[235] = _createTextVNode(" If you find it useful, please consider supporting it with a small donation using one of these platforms: ", -1 /* CACHED */)),
                          _createElementVNode("div", _hoisted_106, [
                            _createElementVNode("div", _hoisted_107, [
                              _createElementVNode("a", _hoisted_108, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "fa-brands fa-github",
                                  size: "2x"
                                }),
                                _cache[227] || (_cache[227] = _createElementVNode("div", null, "GitHub Sponsor", -1 /* CACHED */))
                              ]),
                              _cache[228] || (_cache[228] = _createElementVNode("div", { style: {"font-size":"0.7em","color":"#aaa","position":"absolute","bottom":"-0.8rem","left":"50%","transform":"translateX(-50%)"} }, " (No fees!) ", -1 /* CACHED */))
                            ]),
                            _cache[230] || (_cache[230] = _createElementVNode("div", null, "or", -1 /* CACHED */)),
                            _createElementVNode("div", null, [
                              _createElementVNode("a", _hoisted_109, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "fa-brands fa-paypal",
                                  size: "2x"
                                }),
                                _cache[229] || (_cache[229] = _createElementVNode("div", null, "PayPal", -1 /* CACHED */))
                              ])
                            ])
                          ]),
                          _cache[236] || (_cache[236] = _createTextVNode(" Your support will help keep the project online, updated, and will motivate me to add new features.", -1 /* CACHED */)),
                          _cache[237] || (_cache[237] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                          _cache[238] || (_cache[238] = _createElementVNode("div", { style: {"text-align":"right"} }, "Thank you! — Sen", -1 /* CACHED */))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_110, [
                      _cache[241] || (_cache[241] = _createElementVNode("div", { class: "section-title" }, [
                        _createElementVNode("h2", null, "Tools")
                      ], -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_111, [
                        _createElementVNode("div", _hoisted_112, [
                          _createElementVNode("div", {
                            onClick: _cache[92] || (_cache[92] = ($event: any) => (_ctx.displayedModal = 'importdeck')),
                            class: "link"
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-file-export" }),
                            _cache[239] || (_cache[239] = _createTextVNode(" Card List Importer ", -1 /* CACHED */))
                          ]),
                          (_ctx.sessionID)
                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_113, [
                                _createElementVNode("a", {
                                  href: `/getCollectionPlainText/${encodeURIComponent(_ctx.sessionID)}`,
                                  target: "_blank"
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-file-download" }),
                                  _cache[240] || (_cache[240] = _createTextVNode(" Download Session Collection ", -1 /* CACHED */))
                                ], 8 /* PROPS */, _hoisted_114)
                              ])), [
                                [_directive_tooltip, 
											'Download the intersection of the collections of players in the session in text format.'
										]
                              ])
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_115, [
                    _cache[243] || (_cache[243] = _createElementVNode("div", { class: "section-title" }, [
                      _createElementVNode("h2", null, "Public Sessions")
                    ], -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_116, [
                      (_ctx.userID === _ctx.sessionOwner)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                            _createElementVNode("button", {
                              onClick: _cache[93] || (_cache[93] = ($event: any) => (_ctx.isPublic = !_ctx.isPublic))
                            }, " Set session as " + _toDisplayString(_ctx.isPublic ? "Private" : "Public"), 1 /* TEXT */),
                            _createVNode(_component_delayed_input, {
                              style: {"flex-grow":"1"},
                              modelValue: _ctx.description,
                              "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.description) = $event)),
                              type: "text",
                              placeholder: "Enter a description for your session",
                              maxlength: 70
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (_ctx.publicSessions.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_118, "No public sessions"))
                        : (_openBlock(), _createElementBlock("table", _hoisted_119, [
                            _cache[242] || (_cache[242] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "ID"),
                                _createElementVNode("th", null, "Set(s)"),
                                _createElementVNode("th", null, "Players"),
                                _createElementVNode("th", null, "Description"),
                                _createElementVNode("th", null, "Join")
                              ])
                            ], -1 /* CACHED */)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publicSessions, (s) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: s.id
                                }, [
                                  _createElementVNode("td", {
                                    title: s.id,
                                    class: "id"
                                  }, _toDisplayString(s.id), 9 /* TEXT, PROPS */, _hoisted_120),
                                  _withDirectives((_openBlock(), _createElementBlock("td", null, [
                                    (s.cube)
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_121))
                                      : (s.sets.length === 1)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            src: _ctx.setsInfos[s.sets[0]].icon,
                                            class: "set-icon"
                                          }, null, 8 /* PROPS */, _hoisted_122))
                                        : (s.sets.length === 0)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                              _createTextVNode("All")
                                            ], 64 /* STABLE_FRAGMENT */))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                              _createTextVNode("[" + _toDisplayString(s.sets.length) + "]", 1 /* TEXT */)
                                            ], 64 /* STABLE_FRAGMENT */))
                                  ])), [
                                    [_directive_tooltip, 
												s.cube
													? 'Cube'
													: s.sets.map((code) => _ctx.setsInfos[code].fullName).join(', ')
											]
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(s.players) + " / " + _toDisplayString(s.maxPlayers), 1 /* TEXT */),
                                  _createElementVNode("td", _hoisted_123, _toDisplayString(s.description), 1 /* TEXT */),
                                  _createElementVNode("td", null, [
                                    (s.id !== _ctx.sessionID)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          onClick: ($event: any) => (_ctx.sessionID = s.id)
                                        }, "Join", 8 /* PROPS */, _hoisted_124))
                                      : _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 1,
                                          icon: "fa-solid fa-check",
                                          class: "green"
                                        }, null, 512 /* NEED_PATCH */)), [
                                          [_directive_tooltip, `You are in this session!`]
                                        ])
                                  ])
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                    ])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(_component_modal, {
      displayed: _ctx.displayedModal === 'help',
      onClose: _cache[96] || (_cache[96] = ($event: any) => (_ctx.displayedModal = ''))
    }, {
      header: _withCtx(() => [...(_cache[246] || (_cache[246] = [
        _createElementVNode("h2", null, "Help", -1 /* CACHED */)
      ]))]),
      body: _withCtx(() => [
        _createVNode(_component_help_modal, {
          onOpenSettings: _cache[95] || (_cache[95] = ($event: any) => (_ctx.displayedModal = 'sessionOptions'))
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed"]),
    _createVNode(_component_modal, {
      displayed: _ctx.displayedModal === 'gettingStarted',
      onClose: _cache[98] || (_cache[98] = ($event: any) => (_ctx.displayedModal = ''))
    }, {
      header: _withCtx(() => [...(_cache[247] || (_cache[247] = [
        _createElementVNode("h2", null, "Getting Started", -1 /* CACHED */)
      ]))]),
      body: _withCtx(() => [
        _createVNode(_component_getting_started, {
          isSessionOwner: _ctx.userID === _ctx.sessionOwner,
          sessionOwnerName: _ctx.sessionOwner ? _ctx.userByID[_ctx.sessionOwner].userName : 'Unknown',
          onOpenSettings: _cache[97] || (_cache[97] = ($event: any) => (_ctx.displayedModal = 'sessionOptions')),
          onSessionURLToClipboard: _ctx.sessionURLToClipboard
        }, null, 8 /* PROPS */, ["isSessionOwner", "sessionOwnerName", "onSessionURLToClipboard"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed"]),
    _createVNode(_component_modal, {
      displayed: _ctx.displayedModal === 'collectionHelp',
      onClose: _cache[99] || (_cache[99] = ($event: any) => (_ctx.displayedModal = ''))
    }, {
      header: _withCtx(() => [...(_cache[248] || (_cache[248] = [
        _createElementVNode("h2", null, "Collection Import Help", -1 /* CACHED */)
      ]))]),
      body: _withCtx(() => [
        _createVNode(_component_CollectionImportHelp, {
          onUploadlogs: _ctx.uploadMTGALogs,
          onClipboard: _ctx.toClipboard
        }, null, 8 /* PROPS */, ["onUploadlogs", "onClipboard"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed"]),
    _createVNode(_component_modal, {
      displayed: _ctx.displayedModal === 'importdeck',
      onClose: _cache[101] || (_cache[101] = ($event: any) => (_ctx.displayedModal = ''))
    }, {
      header: _withCtx(() => [...(_cache[249] || (_cache[249] = [
        _createElementVNode("h2", null, "Card List Importer", -1 /* CACHED */)
      ]))]),
      body: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("form", {
            onSubmit: _cache[100] || (_cache[100] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.importDeck && _ctx.importDeck(...args)), ["prevent"]))
          }, [...(_cache[250] || (_cache[250] = [
            _createElementVNode("div", null, [
              _createElementVNode("textarea", {
                placeholder: "Paste cards here... any list MTGA accepts should work",
                rows: "15",
                cols: "40",
                id: "decklist-text"
              })
            ], -1 /* CACHED */),
            _createElementVNode("div", null, [
              _createElementVNode("button", { type: "submit" }, "Import")
            ], -1 /* CACHED */)
          ]))], 32 /* NEED_HYDRATION */)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed"]),
    _createVNode(_component_modal, {
      displayed: _ctx.displayedModal === 'uploadBoosters',
      onClose: _cache[103] || (_cache[103] = ($event: any) => (_ctx.displayedModal = 'sessionOptions'))
    }, {
      header: _withCtx(() => [...(_cache[251] || (_cache[251] = [
        _createElementVNode("h2", null, "Upload Boosters", -1 /* CACHED */)
      ]))]),
      body: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("form", {
            onSubmit: _cache[102] || (_cache[102] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.uploadBoosters && _ctx.uploadBoosters(...args)), ["prevent"]))
          }, [...(_cache[252] || (_cache[252] = [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _createTextVNode(" Paste your boosters card list here. One card per line, each booster separated by a blank line."),
                _createElementVNode("br"),
                _createTextVNode(" Make sure each booster has the same number of cards and the total booster count is suitable for your settings. ")
              ]),
              _createElementVNode("textarea", {
                placeholder: "Paste cards here...",
                rows: "15",
                cols: "40",
                id: "upload-booster-text"
              })
            ], -1 /* CACHED */),
            _createElementVNode("div", null, [
              _createElementVNode("button", { type: "submit" }, "Upload")
            ], -1 /* CACHED */)
          ]))], 32 /* NEED_HYDRATION */)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed"]),
    _createVNode(_component_modal, {
      displayed: _ctx.displayedModal === 'setRestriction',
      onClose: _cache[105] || (_cache[105] = ($event: any) => (_ctx.displayedModal = ''))
    }, {
      header: _withCtx(() => [...(_cache[253] || (_cache[253] = [
        _createElementVNode("h2", null, "Card Pool", -1 /* CACHED */)
      ]))]),
      body: _withCtx(() => [
        _createVNode(_component_set_restriction_component, {
          modelValue: _ctx.setRestriction,
          "onUpdate:modelValue": _cache[104] || (_cache[104] = ($event: any) => ((_ctx.setRestriction) = $event))
        }, null, 8 /* PROPS */, ["modelValue"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed"]),
    _createVNode(_component_modal, {
      displayed: _ctx.displayedModal === 'draftLogs',
      onClose: _cache[107] || (_cache[107] = ($event: any) => (_ctx.displayedModal = ''))
    }, {
      header: _withCtx(() => [...(_cache[254] || (_cache[254] = [
        _createElementVNode("h2", null, "Game Logs", -1 /* CACHED */)
      ]))]),
      body: _withCtx(() => [
        _createVNode(_component_draft_log_history, {
          draftLogs: _ctx.draftLogs,
          language: _ctx.language,
          userID: _ctx.userID,
          userName: _ctx.userName,
          onSharelog: _ctx.shareSavedDraftLog,
          onStorelogs: _ctx.storeDraftLogs,
          onLoadDeck: _ctx.loadDeckFromLogs,
          onImportMTGOLog: _ctx.importMTGOLog,
          onReloadBoosters: _cache[106] || (_cache[106] = (str) => _ctx.setBoosters(str))
        }, null, 8 /* PROPS */, ["draftLogs", "language", "userID", "userName", "onSharelog", "onStorelogs", "onLoadDeck", "onImportMTGOLog"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed"]),
    _createVNode(_component_modal, {
      displayed: _ctx.displayedModal === 'collection',
      onClose: _cache[109] || (_cache[109] = ($event: any) => (_ctx.displayedModal = ''))
    }, {
      header: _withCtx(() => [...(_cache[255] || (_cache[255] = [
        _createElementVNode("h2", null, "Collection Statistics", -1 /* CACHED */)
      ]))]),
      body: _withCtx(() => [
        _createVNode(_component_collection_component, {
          collection: _ctx.collection,
          collectionInfos: _ctx.collectionInfos,
          language: _ctx.language,
          displaycollectionstatus: _ctx.displayCollectionStatus,
          onDisplayCollectionStatus: _cache[108] || (_cache[108] = ($event: any) => (_ctx.displayCollectionStatus = $event))
        }, null, 8 /* PROPS */, ["collection", "collectionInfos", "language", "displaycollectionstatus"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed"]),
    _createVNode(_component_modal, {
      displayed: _ctx.displayedModal === 'sessionOptions',
      onClose: _cache[153] || (_cache[153] = ($event: any) => (_ctx.displayedModal = ''))
    }, {
      header: _withCtx(() => [...(_cache[256] || (_cache[256] = [
        _createElementVNode("h2", null, "Additional Session Settings", -1 /* CACHED */)
      ]))]),
      contols: _withCtx(() => [
        _createElementVNode("div", null, [
          _withDirectives(_createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-undo",
            class: _normalizeClass(["clickable", { disabled: _ctx.userID !== _ctx.sessionOwner }]),
            onClick: _ctx.resetSessionSettings
          }, null, 8 /* PROPS */, ["class", "onClick"]), [
            [_directive_tooltip, 'Reset all session settings to their default value']
          ])
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["session-options-container", { disabled: _ctx.userID != _ctx.sessionOwner }])
        }, [
          _createElementVNode("div", _hoisted_125, [
            _cache[275] || (_cache[275] = _createElementVNode("h4", null, "Session", -1 /* CACHED */)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_126, [
              _cache[257] || (_cache[257] = _createElementVNode("label", { for: "is-public" }, "Public", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_127, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[110] || (_cache[110] = ($event: any) => ((_ctx.isPublic) = $event)),
                  id: "is-public"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.isPublic]
                ])
              ])
            ])), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content: '<p>Display this session on the front page, allowing any visitor to join.</p>',
								html: true,
							},
                void 0,
                { left: true }
              ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_128, [
              _cache[258] || (_cache[258] = _createElementVNode("label", { for: "session-desc" }, "Description", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_129, [
                _createVNode(_component_delayed_input, {
                  id: "session-desc",
                  modelValue: _ctx.description,
                  "onUpdate:modelValue": _cache[111] || (_cache[111] = ($event: any) => ((_ctx.description) = $event)),
                  type: "text",
                  placeholder: "Session public description",
                  maxlength: 70,
                  style: {"width":"90%"}
                }, null, 8 /* PROPS */, ["modelValue"])
              ])
            ])), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content:
									'<p>Public description for your session. Ex: Peasant Cube, will launch at 8pm. Matches played on Arena.</p>',
								html: true,
							},
                void 0,
                { left: true }
              ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_130, [
              _cache[259] || (_cache[259] = _createElementVNode("label", { for: "is-owner-player" }, "Spectate as Session Owner", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_131, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[112] || (_cache[112] = ($event: any) => ((_ctx.ownerIsPlayer) = $event)),
                  "true-value": false,
                  "false-value": true,
                  id: "is-owner-player"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.ownerIsPlayer]
                ])
              ])
            ])), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content: `<p>Spectate the game as the Session Owner, without participating.<br>
								If checked, the owner will still be able to observe the picks of each player (as long as the logs are available).<br>
								Mostly useful to tournament organizers.</p>`,
								html: true,
							},
                void 0,
                { left: true }
              ]
            ]),
            _createElementVNode("div", _hoisted_132, [
              _cache[260] || (_cache[260] = _createElementVNode("label", { for: "max-players" }, "Maximum Players", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_133, [
                _withDirectives(_createElementVNode("input", {
                  class: "small-number-input",
                  type: "number",
                  id: "max-players",
                  min: "1",
                  step: "1",
                  "onUpdate:modelValue": _cache[113] || (_cache[113] = ($event: any) => ((_ctx.maxPlayers) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [
                    _vModelText,
                    _ctx.maxPlayers,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ]),
            _cache[276] || (_cache[276] = _createElementVNode("h4", null, "Booster Generation", -1 /* CACHED */)),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["line", { disabled: _ctx.usePredeterminedBoosters }])
            }, [
              _cache[261] || (_cache[261] = _createElementVNode("label", { for: "color-balance" }, "Color Balance", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_134, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[114] || (_cache[114] = ($event: any) => ((_ctx.colorBalance) = $event)),
                  id: "color-balance"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.colorBalance]
                ])
              ])
            ], 2 /* CLASS */)), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content:
									'<p>If set, the system will attempt to smooth out the color distribution in each pack, as opposed to being completely random.</p>',
								html: true,
							},
                void 0,
                { left: true }
              ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["line", { disabled: _ctx.usePredeterminedBoosters || _ctx.useCustomCardList }])
            }, [
              _cache[262] || (_cache[262] = _createElementVNode("label", { for: "mythic-promotion" }, "Rare promotion to Mythic", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_135, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[115] || (_cache[115] = ($event: any) => ((_ctx.mythicPromotion) = $event)),
                  id: "mythic-promotion"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.mythicPromotion]
                ])
              ])
            ], 2 /* CLASS */)), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content:
									'<p>If enabled (default) Rares can be promoted to a Mythic at a 1/8 rate.</p><p>Disabled for Custom Card Lists.</p>',
								html: true,
							},
                void 0,
                { left: true }
              ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["line", { disabled: _ctx.usePredeterminedBoosters || _ctx.useCustomCardList }])
            }, [
              _cache[263] || (_cache[263] = _createElementVNode("label", { for: "option-foil" }, "Foil", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_136, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[116] || (_cache[116] = ($event: any) => ((_ctx.foil) = $event)),
                  id: "option-foil"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.foil]
                ])
              ])
            ], 2 /* CLASS */)), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content:
									'<p>If enabled, each pack will have a chance to contain a \'foil\' card of any rarity in place of one common.</p>',
								html: true,
							},
                void 0,
                { left: true }
              ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["line", { disabled: _ctx.usePredeterminedBoosters }])
            }, [
              _cache[264] || (_cache[264] = _createElementVNode("label", { for: "restrict-to-collections" }, "Restrict card pool to Collections", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_137, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: !_ctx.ignoreCollections,
                  id: "restrict-to-collections",
                  onChange: _cache[117] || (_cache[117] = ($event: any) => (_ctx.ignoreCollections = !($event.target! as HTMLInputElement).checked))
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_138)
              ])
            ], 2 /* CLASS */)), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content: `Restrict card pool to Player Collections: <strong>${
									_ctx.ignoreCollections ? 'Disabled' : 'Enabled'
								}</strong>
									<p>If enabled, card pool will be limited to cards present in all player collections.</p>`,
								html: true,
							},
                void 0,
                { left: true }
              ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["option-section", { disabled: _ctx.usePredeterminedBoosters || _ctx.useCustomCardList }])
            }, [
              _createElementVNode("div", _hoisted_139, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[118] || (_cache[118] = ($event: any) => ((_ctx.useBoosterContent) = $event)),
                  id: "edit-booster-content"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.useBoosterContent]
                ]),
                _cache[265] || (_cache[265] = _createElementVNode("label", { for: "edit-booster-content" }, "Edit Booster Content", -1 /* CACHED */))
              ]),
              (_ctx.useBoosterContent)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(['common', 'uncommon', 'rare', 'bonus'], (r) => {
                    return _createElementVNode("div", {
                      class: "line",
                      key: r
                    }, [
                      _createElementVNode("label", {
                        for: 'booster-content-' + r,
                        class: "capitalized"
                      }, _toDisplayString(r), 9 /* TEXT, PROPS */, _hoisted_140),
                      _createElementVNode("div", _hoisted_141, [
                        _withDirectives(_createElementVNode("input", {
                          class: "small-number-input",
                          type: "number",
                          id: 'booster-content-' + r,
                          min: "0",
                          max: "30",
                          step: "1",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.boosterContent[r as keyof typeof boosterContent]) = $event),
                          onChange: ($event: any) => {
												if (_ctx.boosterContent[r as keyof typeof boosterContent] < 0)
													_ctx.boosterContent[r as keyof typeof boosterContent] = 0;
											}
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_142), [
                          [
                            _vModelText,
                            _ctx.boosterContent[r as keyof typeof boosterContent],
                            void 0,
                            { number: true }
                          ]
                        ])
                      ])
                    ])
                  }), 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content: `<p>Lets you customize the exact content of your boosters.</p>
									<p><strong>Bonus</strong>: Controls the number of cards from a set-specific bonus sheet, they generally replace commons (and thus do not increase booster size). This setting only affect the following sets: 
										<ul>
											<li>March of the Machine (Multiverse Legends)</li> 
											<li>Shadows over Innistrad Remastered (Shadow of the Past)</li> 
											<li>The Brothers' War (Retro Artifact - These do NOT replace commons)</li> 
											<li>Strixhaven (Mystical Archives)</li> 
											<li>Timespiral Remastered (Timeshifted - These do NOT replace commons)</li> 
											<li>Modern Horizons 2 (New-to-Modern - These do NOT replace commons)</li> 
										</ul>
									</p>
									<p>Notes:<ul><li>Zero is a valid value (useful for Pauper or Artisan for example).</li><li>A land slot will be automatically added for some sets.</li><li>Unused when drawing from a custom card list: See the advanced card list syntax to mimic it.</li></ul></p>`,
								html: true,
							},
                void 0,
                { left: true }
              ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["option-section", { disabled: _ctx.usePredeterminedBoosters || _ctx.useCustomCardList }])
            }, [
              _createElementVNode("div", _hoisted_143, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: _ctx.maxDuplicates !== null,
                  onClick: _cache[119] || (_cache[119] = 
//@ts-ignore
(...args) => (_ctx.toggleLimitDuplicates && _ctx.toggleLimitDuplicates(...args))),
                  id: "max-duplicate-title"
                }, null, 8 /* PROPS */, _hoisted_144),
                _cache[266] || (_cache[266] = _createElementVNode("label", { for: "max-duplicate-title" }, "Limit duplicates", -1 /* CACHED */))
              ]),
              (_ctx.maxDuplicates !== null)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Object.keys(_ctx.maxDuplicates), (r) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "line",
                      key: r
                    }, [
                      _createElementVNode("label", {
                        for: 'max-duplicates-' + r,
                        class: "capitalized"
                      }, _toDisplayString(r) + "s", 9 /* TEXT, PROPS */, _hoisted_145),
                      _createElementVNode("div", _hoisted_146, [
                        _withDirectives(_createElementVNode("input", {
                          class: "small-number-input",
                          type: "number",
                          id: 'max-duplicates-' + r,
                          min: "1",
                          max: "16",
                          step: "1",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.maxDuplicates[r as keyof typeof maxDuplicates]) = $event),
                          onChange: ($event: any) => {
												if (_ctx.maxDuplicates![r as keyof typeof maxDuplicates] < 1)
													_ctx.maxDuplicates![r as keyof typeof maxDuplicates] = 1;
											}
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_147), [
                          [
                            _vModelText,
                            _ctx.maxDuplicates[r as keyof typeof maxDuplicates],
                            void 0,
                            { number: true }
                          ]
                        ])
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content:
									'<p>Sets a duplicate limit for each rarity across the entire draft. Only used if no player collection is used to limit the card pool. Default: Off.</p>',
								html: true,
							},
                void 0,
                { left: true }
              ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_148, [
              _cache[269] || (_cache[269] = _createElementVNode("label", { for: "use-predetermined-boosters" }, "Use Pre-Determined Boosters", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_149, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[120] || (_cache[120] = ($event: any) => ((_ctx.usePredeterminedBoosters) = $event)),
                  id: "use-predetermined-boosters"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.usePredeterminedBoosters]
                ]),
                _createElementVNode("button", {
                  onClick: _cache[121] || (_cache[121] = ($event: any) => (_ctx.displayedModal = 'uploadBoosters'))
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-upload" }),
                  _cache[267] || (_cache[267] = _createTextVNode(" Upload ", -1 /* CACHED */))
                ]),
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  onClick: _cache[122] || (_cache[122] = 
//@ts-ignore
(...args) => (_ctx.shuffleUploadedBoosters && _ctx.shuffleUploadedBoosters(...args)))
                }, [...(_cache[268] || (_cache[268] = [
                  _createTextVNode(" Shuffle ", -1 /* CACHED */)
                ]))])), [
                  [_directive_tooltip, 'Shuffle the boosters before distributing them.']
                ])
              ])
            ])), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content: '<p>Upload your own boosters.</p>',
								html: true,
							},
                void 0,
                { left: true }
              ]
            ]),
            _cache[277] || (_cache[277] = _createElementVNode("h4", null, "Game Logs", -1 /* CACHED */)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_150, [
              _cache[270] || (_cache[270] = _createElementVNode("label", { for: "option-personal-logs" }, "Personal Logs", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_151, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[123] || (_cache[123] = ($event: any) => ((_ctx.personalLogs) = $event)),
                  id: "option-personal-logs"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.personalLogs]
                ])
              ])
            ])), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content:
									'<p>If enabled, players will receive a log of their own draft, regardless of the full game log settings.</p>',
								html: true,
							},
                void 0,
                { left: true }
              ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_152, [
              _cache[272] || (_cache[272] = _createElementVNode("label", { for: "draft-log-recipients" }, "Send full game logs to", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_153, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[124] || (_cache[124] = ($event: any) => ((_ctx.draftLogRecipients) = $event)),
                  id: "draft-log-recipients"
                }, [...(_cache[271] || (_cache[271] = [
                  _createElementVNode("option", { value: "everyone" }, "Everyone", -1 /* CACHED */),
                  _createElementVNode("option", { value: "delayed" }, "Everyone, on owner approval", -1 /* CACHED */),
                  _createElementVNode("option", { value: "owner" }, "Owner only", -1 /* CACHED */),
                  _createElementVNode("option", { value: "none" }, "No-one", -1 /* CACHED */)
                ]))], 512 /* NEED_PATCH */), [
                  [_vModelSelect, _ctx.draftLogRecipients]
                ])
              ])
            ])), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content:
									'<p>Controls who is going to receive the full game logs. Note that this setting doesn\'t affect personal logs.</p><p>\'Everyone, on owner approval\': The session owner will choose when to reveal the full game logs. Useful for tournaments.</p>',
								html: true,
							},
                void 0,
                { left: true }
              ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["line", { disabled: _ctx.draftLogRecipients !== 'delayed' }])
            }, [
              _cache[274] || (_cache[274] = _createElementVNode("label", { for: "draft-log-unlock-timer" }, "Automatic Logs Unlock Timer", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_154, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[125] || (_cache[125] = ($event: any) => ((_ctx.draftLogUnlockTimer) = $event)),
                  id: "draft-log-unlock-timer"
                }, [...(_cache[273] || (_cache[273] = [
                  _createElementVNode("option", { value: 0 }, "Never", -1 /* CACHED */),
                  _createElementVNode("option", { value: 60 }, "1h", -1 /* CACHED */),
                  _createElementVNode("option", { value: 120 }, "2h", -1 /* CACHED */),
                  _createElementVNode("option", { value: 180 }, "3h", -1 /* CACHED */)
                ]))], 512 /* NEED_PATCH */), [
                  [_vModelSelect, _ctx.draftLogUnlockTimer]
                ])
              ])
            ], 2 /* CLASS */)), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content:
									'<p>Automatically unlocks the draft logs for the entire session once the specified delay has elapsed. This feature is particularly useful for owners who may occasionally forget to unlock the logs :)</p><p>Note: Please remain connected to the session to ensure that you receive the logs. If the session remains inactive for an extended period, the server might drop the logs. At that point, only the owner will be able to share the logs.</p>',
								html: true,
							},
                void 0,
                { left: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_155, [
            _cache[299] || (_cache[299] = _createElementVNode("h4", null, "Draft Specific Settings", -1 /* CACHED */)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_156, [
              _cache[278] || (_cache[278] = _createElementVNode("label", { for: "team-draft" }, "Team Draft", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_157, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "team-draft",
                  "onUpdate:modelValue": _cache[126] || (_cache[126] = ($event: any) => ((_ctx.teamDraft) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.teamDraft]
                ])
              ])
            ])), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content:
									'<p>Team Draft, which is a 6-player, 3v3 mode where teams alternate seats.</p><p>This setting is mostly visual, but creates an appropriate bracket tournament where each player will only play players from the other team.</p>',
								html: true,
							},
                void 0,
                { right: true }
              ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_158, [
              _cache[279] || (_cache[279] = _createElementVNode("label", { for: "boosters-per-player" }, "Boosters per Player", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_159, [
                _createVNode(_component_delayed_input, {
                  type: "number",
                  id: "boosters-per-player",
                  class: "small-number-input",
                  min: 1,
                  max: 99,
                  step: 1,
                  delay: 0.1,
                  modelValue: _ctx.boostersPerPlayer,
                  "onUpdate:modelValue": _cache[127] || (_cache[127] = ($event: any) => ((_ctx.boostersPerPlayer) = $event)),
                  modelModifiers: { number: true },
                  validate: (v) => Math.max(1, Math.min(v, 99))
                }, null, 8 /* PROPS */, ["modelValue", "validate"])
              ])
            ])), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content: '<p>Draft: Boosters per Player; default is 3.</p>',
								html: true,
							},
                void 0,
                { right: true }
              ]
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["option-section", { disabled: _ctx.usePredeterminedBoosters || _ctx.useCustomCardList }])
            }, [
              _cache[287] || (_cache[287] = _createElementVNode("div", { class: "option-column-title" }, "Individual Booster Set", -1 /* CACHED */)),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_160, [
                _cache[281] || (_cache[281] = _createElementVNode("label", { for: "distribution-mode" }, "Distribution Mode", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("select", {
                  class: "right",
                  "onUpdate:modelValue": _cache[128] || (_cache[128] = ($event: any) => ((_ctx.distributionMode) = $event)),
                  name: "distributionMode",
                  id: "distribution-mode"
                }, [...(_cache[280] || (_cache[280] = [
                  _createElementVNode("option", { value: "regular" }, "Regular", -1 /* CACHED */),
                  _createElementVNode("option", { value: "shufflePlayerBoosters" }, "Shuffle Player Boosters", -1 /* CACHED */),
                  _createElementVNode("option", { value: "shuffleBoosterPool" }, "Shuffle Booster Pool", -1 /* CACHED */),
                  _createElementVNode("option", { value: "staggered" }, "Staggered", -1 /* CACHED */)
                ]))], 512 /* NEED_PATCH */), [
                  [_vModelSelect, _ctx.distributionMode]
                ])
              ])), [
                [
                  _directive_tooltip,
                  {
									popperClass: 'option-tooltip',
									content:
										'<p>Controls how the boosters will be distributed. This setting will have no effect if no individual booster rules are specified below.</p><ul><li>Regular: Every player will receive boosters from the same sets and will open them in the specified order.</li><li>Shuffle Player Boosters: Each player will receive boosters from the same sets but will open them in a random order.</li><li>Shuffle Booster Pool: Boosters will be shuffled all together and randomly handed to each player.</li></ul>',
									html: true,
								},
                  void 0,
                  { right: true }
                ]
              ]),
              _cache[288] || (_cache[288] = _createElementVNode("hr", { style: {"margin":"0.4em 1em","color":"#555"} }, null, -1 /* CACHED */)),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_161, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customBoosters, (value, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "line",
                    key: index
                  }, [
                    _createElementVNode("label", _hoisted_162, "Booster #" + _toDisplayString(index + 1), 1 /* TEXT */),
                    _withDirectives(_createElementVNode("select", {
                      class: "right",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.customBoosters[index]) = $event)
                    }, [
                      _cache[282] || (_cache[282] = _createElementVNode("option", { value: "" }, "(Default)", -1 /* CACHED */)),
                      _cache[283] || (_cache[283] = _createElementVNode("option", { value: "random" }, "Random Set from Card Pool", -1 /* CACHED */)),
                      _cache[284] || (_cache[284] = _createElementVNode("option", { value: "randomShared" }, "Random Set from Card Pool (Shared)", -1 /* CACHED */)),
                      _cache[285] || (_cache[285] = _createElementVNode("option", {
                        style: {"color":"#888"},
                        disabled: ""
                      }, "————————————————", -1 /* CACHED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sets.slice().reverse(), (code) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: code,
                          key: code
                        }, _toDisplayString(_ctx.setsInfos[code].fullName), 9 /* TEXT, PROPS */, _hoisted_164))
                      }), 128 /* KEYED_FRAGMENT */)),
                      _cache[286] || (_cache[286] = _createElementVNode("option", {
                        style: {"color":"#888"},
                        disabled: ""
                      }, "————————————————", -1 /* CACHED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.primarySets.filter((s) => !_ctx.sets.includes(s)), (code) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: code,
                          key: code
                        }, _toDisplayString(_ctx.setsInfos[code].fullName), 9 /* TEXT, PROPS */, _hoisted_165))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 8 /* PROPS */, _hoisted_163), [
                      [_vModelSelect, _ctx.customBoosters[index]]
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])), [
                [
                  _directive_tooltip,
                  {
									popperClass: 'option-tooltip',
									content:
										'<p>Specify the set of indiviual boosters handed to each player. Useful for classic Chaos Draft or Ixalan/Rivals of Ixalan draft for example.</p><p>Note: Collections are ignored for each booster with any other value than (Default).</p><p>\'Random Set from Card Pool\' will pick a different extension for each player, \'Random Set from Card Pool (Shared)\' means the randomly picked set will be the same for all players.</p>',
									html: true,
								},
                  void 0,
                  { right: true }
                ]
              ])
            ], 2 /* CLASS */),
            _createElementVNode("div", {
              class: _normalizeClass({
								disabled: _ctx.useCustomCardList && _ctx.customCardList?.settings?.boosterSettings,
							})
            }, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_166, [
                _cache[290] || (_cache[290] = _createElementVNode("label", { for: "picked-cards-per-round" }, "Picked cards per booster", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_167, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    id: "picked-cards-per-round",
                    class: "small-number-input",
                    min: "1",
                    step: "1",
                    "onUpdate:modelValue": _cache[129] || (_cache[129] = ($event: any) => ((_ctx.pickedCardsPerRound) = $event)),
                    onChange: _cache[130] || (_cache[130] = ($event: any) => {if (_ctx.pickedCardsPerRound < 1) _ctx.pickedCardsPerRound = 1;})
                  }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [
                      _vModelText,
                      _ctx.pickedCardsPerRound,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _cache[289] || (_cache[289] = _createElementVNode("label", { for: "doubleMastersMode" }, "First Pick Only", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "doubleMastersMode",
                    "onUpdate:modelValue": _cache[131] || (_cache[131] = ($event: any) => ((_ctx.doubleMastersMode) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelCheckbox, _ctx.doubleMastersMode]
                  ])
                ])
              ])), [
                [
                  _directive_tooltip,
                  {
									popperClass: 'option-tooltip',
									content:
										'<p>Number of cards to pick from each booster. Useful for Commander Legends for example (2 cards per booster).</p><p>Default is 1.</p><p>First Pick Only: The custom value will only be used for the first pick of each booster, then revert to 1. For example, you should check this with a value of 2 for Double Masters sets.</p>',
									html: true,
								},
                  void 0,
                  { right: true }
                ]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_168, [
                _cache[291] || (_cache[291] = _createElementVNode("label", { for: "burned-cards-per-round" }, "Burned cards per booster", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_169, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    id: "burned-cards-per-round",
                    class: "small-number-input",
                    min: "0",
                    max: "24",
                    step: "1",
                    "onUpdate:modelValue": _cache[132] || (_cache[132] = ($event: any) => ((_ctx.burnedCardsPerRound) = $event)),
                    onChange: _cache[133] || (_cache[133] = ($event: any) => {if (_ctx.burnedCardsPerRound < 0) _ctx.burnedCardsPerRound = 0;})
                  }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [
                      _vModelText,
                      _ctx.burnedCardsPerRound,
                      void 0,
                      { number: true }
                    ]
                  ])
                ])
              ])), [
                [
                  _directive_tooltip,
                  {
									popperClass: 'option-tooltip',
									content:
										'<p>In addition to picking a card, you will also remove this number of cards from the same booster.</p><p>This is typically used in conjunction with a higher count of boosters per player for drafting with 2 to 4 players. Burn or Glimpse Draft is generally 9 boosters per player with 2 cards being burned in addition to a pick.</p><p>Default is 0.</p>',
									html: true,
								},
                  void 0,
                  { right: true }
                ]
              ])
            ], 2 /* CLASS */),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_170, [
              _cache[293] || (_cache[293] = _createElementVNode("label", { for: "discard-remaining-cards" }, "Discard the remaining", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_171, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "discard-remaining-cards",
                  class: "small-number-input",
                  min: "0",
                  max: 
										Math.max(
											Object.values(_ctx.boosterContent).reduce((v, a) => (a += v)),
											_ctx.cardsPerBooster
										) - _ctx.pickedCardsPerRound
									,
                  step: "1",
                  "onUpdate:modelValue": _cache[134] || (_cache[134] = ($event: any) => ((_ctx.discardRemainingCardsAt) = $event)),
                  onChange: _cache[135] || (_cache[135] = ($event: any) => {if (_ctx.discardRemainingCardsAt < 0) _ctx.discardRemainingCardsAt = 0;})
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_172), [
                  [
                    _vModelText,
                    _ctx.discardRemainingCardsAt,
                    void 0,
                    { number: true }
                  ]
                ]),
                _cache[292] || (_cache[292] = _createTextVNode(" cards of each pack ", -1 /* CACHED */))
              ])
            ])), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content: '<p>Discard (burn) the remaining N cards of each packs automatically.</p>',
								html: true,
							},
                void 0,
                { right: true }
              ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_173, [
              _cache[294] || (_cache[294] = _createElementVNode("label", { for: "mutate" }, "Mutate", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_174, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "mutate",
                  "onUpdate:modelValue": _cache[136] || (_cache[136] = ($event: any) => ((_ctx.mutate) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.mutate]
                ])
              ])
            ])), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content:
									'<p>Whenever a pack is passed to another player, swap a random card for another Arena-legal card with the same type, colors, and mana value.</p>',
								html: true,
							},
                void 0,
                { right: true }
              ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_175, [
              _cache[295] || (_cache[295] = _createElementVNode("label", { for: "disable-bot-suggestions" }, "Disable Bot Suggestions", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_176, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "disable-bot-suggestions",
                  "onUpdate:modelValue": _cache[137] || (_cache[137] = ($event: any) => ((_ctx.disableBotSuggestions) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.disableBotSuggestions]
                ])
              ])
            ])), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content:
									'<p>Disable the bot suggestions mechanism for every player in the session. Useful for tournaments for example.</p>',
								html: true,
							},
                void 0,
                { right: true }
              ]
            ]),
            _cache[300] || (_cache[300] = _createElementVNode("h4", null, "Tournament Settings", -1 /* CACHED */)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_177, [
              _cache[296] || (_cache[296] = _createElementVNode("label", { for: "tournament-timer" }, "Tournament Timer", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_178, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "tournament-timer",
                  "onUpdate:modelValue": _cache[138] || (_cache[138] = ($event: any) => ((_ctx.tournamentTimer) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.tournamentTimer]
                ])
              ])
            ])), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content: '<p>Stricter timer starting at 40sec. used in official tournaments.</p>',
								html: true,
							},
                void 0,
                { right: true }
              ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_179, [
              _cache[297] || (_cache[297] = _createElementVNode("label", { for: "review-timer" }, "Review Timer", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_180, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "review-timer",
                  class: "small-number-input",
                  min: "0",
                  step: "15",
                  "onUpdate:modelValue": _cache[139] || (_cache[139] = ($event: any) => ((_ctx.reviewTimer) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [
                    _vModelText,
                    _ctx.reviewTimer,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ])), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content:
									'<p>Controls the initial duration of the review phase between booster, it will increase by 50% after each pack, up to 2 times the initial duration. This is generally used in conjonction with the \'Hide Picks\' settings. A value of 0 disables the review phase.</p>',
								html: true,
							},
                void 0,
                { right: true }
              ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_181, [
              _cache[298] || (_cache[298] = _createElementVNode("label", { for: "hide-picks" }, "Hide Picks", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_182, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "hide-picks",
                  "onUpdate:modelValue": _cache[140] || (_cache[140] = ($event: any) => ((_ctx.hidePicks) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.hidePicks]
                ])
              ])
            ])), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content: '<p>Hide picks during the draft, outside of the review phase.</p>',
								html: true,
							},
                void 0,
                { right: true }
              ]
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["option-section option-custom-card-list", { disabled: _ctx.usePredeterminedBoosters }])
          }, [
            _createElementVNode("div", _hoisted_183, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[141] || (_cache[141] = ($event: any) => ((_ctx.useCustomCardList) = $event)),
                id: "use-custom-card-list"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, _ctx.useCustomCardList]
              ]),
              _cache[301] || (_cache[301] = _createTextVNode(" Custom Card List ", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_184, [
              _createElementVNode("div", {
                class: _normalizeClass(["option-cube-settings-1", {
									'disabled-simple': !_ctx.useCustomCardList,
								}])
              }, [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass({
										'disabled-simple':
											_ctx.useCustomCardList && _ctx.customCardList && _ctx.customCardList.layouts,
									})
                }, [
                  _cache[302] || (_cache[302] = _createElementVNode("label", { for: "cards-per-booster" }, "Cards per Booster", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    id: "cards-per-booster",
                    class: "small-number-input",
                    min: "1",
                    max: "100",
                    step: "1",
                    "onUpdate:modelValue": _cache[142] || (_cache[142] = ($event: any) => ((_ctx.cardsPerBooster) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [
                      _vModelText,
                      _ctx.cardsPerBooster,
                      void 0,
                      { number: true }
                    ]
                  ])
                ], 2 /* CLASS */)), [
                  [
                    _directive_tooltip,
                    {
										popperClass: 'option-tooltip',
										content:
											'<p>Cards per Booster when using a Custom Card List, ignored when using custom sheets; Default is 15.</p>',
										html: true,
									},
                    void 0,
                    { left: true }
                  ]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[143] || (_cache[143] = ($event: any) => ((_ctx.customCardListWithReplacement) = $event)),
                    id: "custom-card-list-with-replacement"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelCheckbox, _ctx.customCardListWithReplacement]
                  ]),
                  _cache[303] || (_cache[303] = _createElementVNode("label", { for: "custom-card-list-with-replacement" }, "With Replacement", -1 /* CACHED */))
                ])), [
                  [
                    _directive_tooltip,
                    {
										popperClass: 'option-tooltip',
										content:
											'<p>If checked, picked cards will be replaced in the card pool, meaning there\'s an unlimited supply of each card in the list.</p>',
										html: true,
									},
                    void 0,
                    { up: true }
                  ]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass({ disabled: _ctx.customCardListWithReplacement })
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _ctx.customCardList?.settings?.refillWhenEmpty ?? false,
                    id: "custom-card-list-refill-when-empty",
                    onChange: _cache[144] || (_cache[144] = 
//@ts-ignore
(...args) => (_ctx.updateCCLRefillWhenEmpty && _ctx.updateCCLRefillWhenEmpty(...args)))
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_185),
                  _cache[304] || (_cache[304] = _createElementVNode("label", { for: "custom-card-list-refill-when-empty" }, "Refill when empty", -1 /* CACHED */))
                ], 2 /* CLASS */)), [
                  [
                    _directive_tooltip,
                    {
										popperClass: 'option-tooltip',
										content:
											'<p>If checked, sheets will be refilled when empty. This allows to draft with more players that originally intended for a specific cube without skewing the distribution too far from the original intent.</p><p>No effect when With Replacement is enabled</p>',
										html: true,
									},
                    void 0,
                    { up: true }
                  ]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[145] || (_cache[145] = ($event: any) => ((_ctx.customCardListDuplicateProtection) = $event)),
                    id: "custom-card-list-duplicate-protection"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelCheckbox, _ctx.customCardListDuplicateProtection]
                  ]),
                  _cache[305] || (_cache[305] = _createElementVNode("label", { for: "custom-card-list-duplicate-protection" }, "Duplicate Protection", -1 /* CACHED */))
                ])), [
                  [
                    _directive_tooltip,
                    {
										popperClass: 'option-tooltip',
										content:
											'<p>When enabled, duplicates of the exact same card in a booster will be avoided as much as possible.</p>',
										html: true,
									},
                    void 0,
                    { up: true }
                  ]
                ])
              ], 2 /* CLASS */),
              (_ctx.customCardList?.sheets && Object.keys(_ctx.customCardList?.sheets).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                    (_ctx.useCustomCardList)
                      ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          icon: "fa-solid fa-check",
                          class: "green"
                        }, null, 512 /* NEED_PATCH */)), [
                          [_directive_tooltip, 'Card list successfully loaded!']
                        ])
                      : _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 1,
                          icon: "fa-solid fa-exclamation-triangle",
                          class: "yellow"
                        }, null, 512 /* NEED_PATCH */)), [
                          [_directive_tooltip, 'Card list successfully loaded, but not used.']
                        ]),
                    (_ctx.customCardList.name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                          _cache[306] || (_cache[306] = _createTextVNode(" Loaded '", -1 /* CACHED */)),
                          _createElementVNode("span", _hoisted_188, _toDisplayString(_ctx.customCardList.name), 1 /* TEXT */),
                          _cache[307] || (_cache[307] = _createTextVNode("'. ", -1 /* CACHED */))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_189, "Unamed list loaded.")),
                    _createElementVNode("button", {
                      onClick: _cache[146] || (_cache[146] = ($event: any) => (_ctx.displayedModal = 'cardList'))
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-file-lines" }),
                      _cache[308] || (_cache[308] = _createTextVNode(" Review. ", -1 /* CACHED */))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_190, "(No Custom Card List loaded)"))
            ]),
            _createElementVNode("div", _hoisted_191, [
              _createElementVNode("input", {
                type: "file",
                id: "card-list-input",
                onChange: _cache[147] || (_cache[147] = ($event: any) => (_ctx.uploadFile($event, _ctx.parseCustomCardList))),
                style: {"display":"none"},
                accept: ".txt"
              }, null, 32 /* NEED_HYDRATION */),
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "file-drop clickable",
                onDrop: _cache[148] || (_cache[148] = 
//@ts-ignore
(...args) => (_ctx.dropCustomList && _ctx.dropCustomList(...args))),
                onclick: "document.querySelector('#card-list-input').click()",
                onDragover: _cache[149] || (_cache[149] = ($event: any) => {
									$event.preventDefault();
									($event.target as HTMLElement)?.classList.add('dropzone-highlight');
								}),
                style: {"flex-grow":"1","height":"100%"}
              }, [...(_cache[309] || (_cache[309] = [
                _createTextVNode(" Upload a Custom Card List file by dropping it here or by clicking to browse your computer. ", -1 /* CACHED */)
              ]))], 32 /* NEED_HYDRATION */)), [
                [
                  _directive_tooltip,
                  {
									popperClass: 'option-tooltip',
									content:
										'<p>Upload any card list from your computer.</p><p>You can use services like Cube Cobra to find cubes or craft your own list and export it to .txt.</p>',
									html: true,
								},
                  void 0,
                  { left: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_192, [
                _createElementVNode("button", {
                  onClick: _cache[150] || (_cache[150] = ($event: any) => (_ctx.importCube('Cube Cobra'))),
                  style: {"position":"relative","width":"100%"}
                }, [...(_cache[310] || (_cache[310] = [
                  _createElementVNode("img", {
                    style: {"position":"absolute","left":"0.2em","top":"10%","height":"80%"},
                    src: _imports_8
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" Import From Cube Cobra ", -1 /* CACHED */)
                ]))])
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_193, [
              _cache[312] || (_cache[312] = _createElementVNode("label", { for: "curated-cubes" }, "Load a Pre-Build Cube:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("select", {
                name: "featured-cubes",
                id: "curated-cubes",
                "onUpdate:modelValue": _cache[151] || (_cache[151] = ($event: any) => ((_ctx.selectedCube) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cubeLists, (cube) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: cube.filename,
                    value: cube
                  }, [
                    _createTextVNode(_toDisplayString(cube.name) + " ", 1 /* TEXT */),
                    (cube.cubeCobraID)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_195, "(Cube Cobra)"))
                      : _createCommentVNode("v-if", true)
                  ], 8 /* PROPS */, _hoisted_194))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.selectedCube]
              ]),
              _createElementVNode("button", {
                onClick: _cache[152] || (_cache[152] = ($event: any) => (_ctx.selectCube(_ctx.selectedCube, true, true))),
                style: {"min-width":"auto"}
              }, [
                (_ctx.selectedCube.cubeCobraID)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_196))
                  : _createCommentVNode("v-if", true),
                _cache[311] || (_cache[311] = _createTextVNode(" Load Cube ", -1 /* CACHED */))
              ])
            ])), [
              [
                _directive_tooltip,
                {
								popperClass: 'option-tooltip',
								content: '<p>Load a pre-built cube from a curated list.</p>',
								html: true,
							},
                void 0,
                { left: true }
              ]
            ]),
            (_ctx.selectedCube)
              ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.selectedCube.name), 1 /* TEXT */),
                  (_ctx.selectedCube.cubeCobraID)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                        _createElementVNode("a", {
                          href: `https://cubecobra.com/cube/overview/${_ctx.selectedCube.cubeCobraID}`,
                          target: "_blank",
                          rel: "noopener nofollow"
                        }, [...(_cache[313] || (_cache[313] = [
                          _createElementVNode("img", {
                            class: "set-icon",
                            src: _imports_8
                          }, null, -1 /* CACHED */),
                          _createTextVNode(" Cube Cobra page ", -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_199)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.selectedCube.description)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        innerHTML: _ctx.selectedCube.description
                      }, null, 8 /* PROPS */, _hoisted_200))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_201, [
              _cache[316] || (_cache[316] = _createTextVNode(" You can find more cubes or craft your own on ", -1 /* CACHED */)),
              _createElementVNode("a", _hoisted_202, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-external-link-alt" }),
                _cache[314] || (_cache[314] = _createTextVNode(" Cube Cobra", -1 /* CACHED */))
              ]),
              _cache[317] || (_cache[317] = _createElementVNode("br", null, null, -1 /* CACHED */)),
              _cache[318] || (_cache[318] = _createTextVNode("Customize your list even further by using all features of the ", -1 /* CACHED */)),
              _createElementVNode("a", _hoisted_203, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-external-link-alt" }),
                _cache[315] || (_cache[315] = _createTextVNode(" format ", -1 /* CACHED */))
              ])
            ])
          ], 2 /* CLASS */)
        ], 2 /* CLASS */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed"]),
    _createVNode(_component_modal, {
      displayed: _ctx.displayedModal === 'bracket',
      onClose: _cache[154] || (_cache[154] = ($event: any) => (_ctx.displayedModal = ''))
    }, {
      header: _withCtx(() => [...(_cache[319] || (_cache[319] = [
        _createElementVNode("h2", null, "Bracket", -1 /* CACHED */)
      ]))]),
      body: _withCtx(() => [
        _createVNode(_component_bracket_component, {
          bracket: _ctx.bracket,
          teamDraft: _ctx.teamDraft,
          editable: _ctx.userID === _ctx.sessionOwner || !_ctx.bracketLocked,
          locked: _ctx.bracketLocked,
          fullcontrol: _ctx.userID === _ctx.sessionOwner,
          sessionID: _ctx.sessionID,
          language: _ctx.language,
          draftlog: _ctx.currentDraftLog,
          onUpdated: _ctx.updateBracket,
          onGenerate: _ctx.generateBracket,
          onLock: _ctx.lockBracket,
          onSyncBracketMTGO: _ctx.syncBracketMTGO
        }, null, 8 /* PROPS */, ["bracket", "teamDraft", "editable", "locked", "fullcontrol", "sessionID", "language", "draftlog", "onUpdated", "onGenerate", "onLock", "onSyncBracketMTGO"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed"]),
    _createVNode(_component_modal, {
      displayed: _ctx.displayedModal === 'sampleHand',
      onClose: _cache[155] || (_cache[155] = ($event: any) => (_ctx.displayedModal = ''))
    }, {
      header: _withCtx(() => [...(_cache[320] || (_cache[320] = [
        _createElementVNode("h2", null, "Sample Hand Generator", -1 /* CACHED */)
      ]))]),
      body: _withCtx(() => [
        _createVNode(_component_sample_hand_generator, {
          language: _ctx.language,
          deck: _ctx.deck,
          lands: _ctx.lands
        }, null, 8 /* PROPS */, ["language", "deck", "lands"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed"]),
    _createVNode(_component_modal, {
      displayed: _ctx.displayedModal === 'deckStats',
      onClose: _cache[156] || (_cache[156] = ($event: any) => (_ctx.displayedModal = ''))
    }, {
      header: _withCtx(() => [...(_cache[321] || (_cache[321] = [
        _createElementVNode("h2", null, "Deck Statistics", -1 /* CACHED */)
      ]))]),
      body: _withCtx(() => [
        _createVNode(_component_card_stats, {
          cards: _ctx.deck,
          addedbasics: _ctx.totalLands
        }, null, 8 /* PROPS */, ["cards", "addedbasics"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed"]),
    _createVNode(_component_modal, {
      displayed: _ctx.displayedModal === 'cardList',
      onClose: _cache[157] || (_cache[157] = ($event: any) => (_ctx.displayedModal = ''))
    }, {
      header: _withCtx(() => [...(_cache[322] || (_cache[322] = [
        _createElementVNode("h2", null, "Custom Card List Review", -1 /* CACHED */)
      ]))]),
      body: _withCtx(() => [
        _createVNode(_component_card_list, {
          cardlist: _ctx.customCardList,
          language: _ctx.language,
          collection: _ctx.collection
        }, null, 8 /* PROPS */, ["cardlist", "language", "collection"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed"]),
    _createVNode(_component_modal, {
      displayed: _ctx.displayedModal === 'About',
      onClose: _cache[158] || (_cache[158] = ($event: any) => (_ctx.displayedModal = ''))
    }, {
      header: _withCtx(() => [...(_cache[323] || (_cache[323] = [
        _createElementVNode("h2", null, "About", -1 /* CACHED */)
      ]))]),
      body: _withCtx(() => [
        _createVNode(_component_About)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed"]),
    _createVNode(_component_modal, {
      displayed: _ctx.displayedModal === 'donation',
      onClose: _cache[159] || (_cache[159] = ($event: any) => (_ctx.displayedModal = ''))
    }, {
      header: _withCtx(() => [...(_cache[324] || (_cache[324] = [
        _createElementVNode("h2", null, "Support Draftmancer", -1 /* CACHED */)
      ]))]),
      body: _withCtx(() => [
        _createVNode(_component_sponsor_modal)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed"]),
    _createVNode(_component_CardPopup, {
      language: _ctx.language,
      customCards: _ctx.customCardList?.customCards,
      ref: "cardPopup"
    }, null, 8 /* PROPS */, ["language", "customCards"]),
    _createElementVNode("footer", null, [
      _createElementVNode("span", {
        onClick: _cache[160] || (_cache[160] = ($event: any) => (_ctx.displayedModal = 'About')),
        class: "clickable"
      }, [...(_cache[325] || (_cache[325] = [
        _createElementVNode("span", { class: "link" }, "About", -1 /* CACHED */)
      ]))]),
      _cache[327] || (_cache[327] = _createElementVNode("span", null, [
        _createTextVNode(" Made by "),
        _createElementVNode("a", {
          href: "https://github.com/sponsors/Senryoku",
          target: "_blank",
          rel: "noopener nofollow"
        }, "Senryoku")
      ], -1 /* CACHED */)),
      _createElementVNode("span", null, [
        _createElementVNode("span", {
          class: "link",
          onClick: _cache[161] || (_cache[161] = ($event: any) => (_ctx.displayedModal = 'donation'))
        }, [
          _cache[326] || (_cache[326] = _createTextVNode(" Buy me a Coffee ", -1 /* CACHED */)),
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-mug-hot",
            "aria-hidden": "true"
          })
        ])
      ]),
      _createElementVNode("span", null, [
        _createElementVNode("a", _hoisted_204, [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-envelope",
            size: "lg",
            style: {"vertical-align":"baseline","padding":"0 0.25em"}
          })
        ]),
        _createElementVNode("a", _hoisted_205, [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-brands fa-discord",
            size: "lg",
            style: {"vertical-align":"baseline","padding":"0 0.25em"}
          })
        ]),
        _createElementVNode("a", _hoisted_206, [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-brands fa-github",
            size: "lg",
            style: {"vertical-align":"baseline","padding":"0 0.25em"}
          })
        ])
      ])
    ]),
    (!_ctx.socketConnected)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_207, [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-exclamation-triangle" }),
          _cache[328] || (_cache[328] = _createTextVNode(" Disconnected ", -1 /* CACHED */))
        ])), [
          [_directive_tooltip, 
				'You are disconnected from the server, some functionnalities won\'t be available until the connection is re-established.'
			]
        ])
      : _createCommentVNode("v-if", true)
  ], 6 /* CLASS, STYLE */))
}